<template>
  <div>
    <loading :active.sync="isloading" :is-full-page="true" color="green"></loading>
       <loading :active.sync="isLoading" :is-full-page="true" color="green"></loading>

    <v-toolbar flat color="white" class="pt-3">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
      <!-- <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=false;archivedPackages=false;unregisteredPackages=false; packageCategories=false;packageTemplates=true"
        >Package Templates</v-tab>
        <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=true;archivedPackages=false;unregisteredPackages=false; packageCategories=false;packageTemplates=false"
        >
          Data Packages
          <v-chip
            small
            dark
            color="success"
            v-if="activepackagesisps.length>0"
          >{{activepackagesisps.length}}</v-chip>
        </v-tab>
        <v-tab
          @click="clearFilters=!clearFilters;summary=false;activeInternetPackages=false;archivedPackages=false;unregisteredPackages=true; packageCategories=false;packageTemplates=false"
        >
          Unregistered Data Packages
          <v-chip
            small
            dark
            color="red"
            v-if="unregisteredpackagesisps.length>0"
          >{{unregisteredpackagesisps.length}}</v-chip>
        </v-tab>
      </v-tabs>-->
    </v-toolbar>
    <!-- <v-toolbar>
      <v-btn @click="bulkUpdateIspPackages()">Update ISP Packages</v-btn>
    </v-toolbar>-->

    <!-- <v-toolbar flat color="white pt-2" v-if="displayContents('activeInternetPackages')">
      <v-spacer></v-spacer>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterNetworkId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterNetwork"
          :items="locationnetworks"
          hide-no-data
          flat
          color="primary"
          label="Network"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterSpeedId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterSpeed"
          :items="filterspeeds"
          hide-no-data
          flat
          color="primary"
          label="Filter by Download Speed (Mbps)"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
          id="filterPackageTypeId"
          clearable
          v-on:keyup.enter="enterEvent"
          v-model="filterPackageType"
          :items="packagetypes"
          hide-no-data
          flat
          color="primary"
          label="Package Type"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-btn id="applyFilterButtonId" flat class="primary" round @click="specifyTab">Apply Filter</v-btn>
      </v-flex>
    </v-toolbar>
    <v-toolbar flat class="white" v-if="displayContents('activeInternetPackages')">
   
      <v-btn round dark class="primary" @click="addItem()">Add Package</v-btn>
    </v-toolbar> -->
    <v-data-table
      v-show="summary"
      :headers="summaryHeaders"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="loading"
      :items="activepackagesisps"
      item-key="id"
      align-center
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.packageCatType}}</td>
        <td class="text-xs-center">{{props.item.packagesFno.speedProfile.name}}</td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">{{props.item.term}}</td>
        <td
          class="text-xs-center"
        >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice) | currency}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Package</h1>
      </v-toolbar>
      <v-card flat v-show="basicInformation">
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  id="addLocationNetworkId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Network"
                  :items="locationnetworks"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationNetworkId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md6 v-if="editedItem.locationNetworkId">
                <v-switch
                  v-model="editedItem.attachPackageToTemplate"
                  label="Attach Package to Template"
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center py-3>
                    <v-btn color="primary" round @click="close">Cancel</v-btn>
                    <v-btn
                      color="primary"
                      round
                      v-show="editedItem.locationNetworkId"
                      @click="basicInformation=false;pricingTerm=true;fetchSelectedNetwork(editedItem.locationNetworkId); getLocationPackages(editedItem.locationNetworkId)"
                    >
                      Next
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card v-show="pricingTerm">
        <v-card-text>
          <h4 class="dark-grey--text">Package Details</h4>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&packagesIspTemplatesLocationNetwork.length>0"
              >
                <v-autocomplete
                  clearable
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Select a Package Template"
                  :items="packagesIspTemplatesLocationNetwork"
                  return-object
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.packagesIspTemplate"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                v-else-if="editedItem.attachPackageToTemplate&&!speedErrorMessage&&packagesIspTemplatesLocationNetwork.length===0"
              >
                <span
                  class="subheading"
                >You have no available Package Templates that match available speeds for this network.</span>
              </v-flex>
              <v-flex
                v-if="editedItem.attachPackageToTemplate&&speedErrorMessage&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''"
              >
                <span
                  class="subheading red--text"
                >Speed of {{editedItem.packagesIspTemplate.speedProfile.name}} is not available on this network.</span>
              </v-flex>
              <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              ></v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.speedProfile.name"
                  label="*Speed Profile"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.name"
                  label="*Package Name"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.description"
                  label="Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.onceOffPrice"
                  label="Once Off Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.recurringPrice"
                  label="Recurring Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.term"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isFup"
                  label="Fair Usage Policy"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              ></v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isCapped"
                  label="Capped"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage&&editedItem.packagesIspTemplate.isCapped"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.cappedAmountGb"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isPromo"
                  label="Promotion"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage&&editedItem.packagesIspTemplate.isPromo"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.promoDescription"
                  label="Promotion Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-layout row justify-center align-center>
                 <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&editedItem.packagesIspTemplate.name!==''&&!speedErrorMessage"
              >
                <h4 class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&!speedErrorMessage&&editedItem.packagesIspTemplate.name!==''&&typeof packagesFnoById!=='undefined'"
              >
                <h4 class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>

              </v-layout>
             
              <v-flex xs12 v-if="!editedItem.attachPackageToTemplate">
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.name"
                  label="*Package Name"
                  hint="This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="!editedItem.attachPackageToTemplate">
                <!-- <froala
                  :tag="'textarea'"
                  :config="textEditorConfig"
                  v-model="editedItem.description"
                ></froala>-->
                <v-textarea
                  class="px-2"
                  v-model="editedItem.description"
                  label="Package Description"
                  hint="Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addPackageFnoId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*FNO Package"
                  :items="locationPackages"
                  item-text="packageCode"
                  item-value="id"
                  required
                  v-model="editedItem.packagesFnoId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addTermId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Contract Term"
                  :items="packageTerms"
                  v-model="editedItem.term"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addRatioId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Layer 3 Contention Ratio"
                  :items="layer3ContentionRatios"
                  v-model="editedItem.layer3Contention"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate"></v-flex>

              <v-flex xs12 sm12 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isPromotion"
                  label="This is a promotional package"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    id="addDateId"
                    :value="this.editedItem.startDate"
                    slot="activator"
                    required
                    label="*Package Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    v-show="editedItem.isPromotion"
                    :value="this.editedItem.endDate"
                    slot="activator"
                    label="Promotion End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                v-show="editedItem.isPromotion&&!editedItem.attachPackageToTemplate"
              >
                <v-textarea
                  v-model="editedItem.promotionDescription"
                  label="Promotion Description"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isCapped"
                  label="Capped"
                  hint="Is this a Capped Package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm12 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isShaped"
                  label="This package is shaped"
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isFup"
                  label="FUP"
                  hint="Do you have a Fair Usage Policy for this package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-show="editedItem.isCapped&&!editedItem.attachPackageToTemplate"
              >
                <v-text-field
                  v-model="editedItem.cappedAmountGb"
                  label="CappedAmount"
                  hint="Capped amount in Gb"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6 v-show="editedItem.isFup">
                <v-text-field
                  v-model="editedItem.fupUrl"
                  label="Fair Usage Policy URL"
                  persistent-hint
                ></v-text-field>
              </v-flex>-->

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn color="primary" round @click="pricingTerm=false;basicInformation=true">
                      <v-icon>keyboard_arrow_left</v-icon>Back
                    </v-btn>
                    <v-btn color="primary" round @click="close; newDialog=false">Cancel</v-btn>
                    <v-btn
                      id="addPackageDetailsNextButtonId"
                      v-show="editedItem.packagesFnoId&& editedItem.layer3Contention&&editedItem.term"
                      color="primary"
                      round
                      @click="getPackageDetails(editedItem.packagesFnoId);pricingTerm=false;packageSummary=true"
                    >
                      Next
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      round
                      v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&packagesIspTemplatesLocationNetwork.length>0&&typeof editedItem.packagesIspTemplate!=='undefined'&&!speedErrorMessage"
                      @click="createPackageFromTemplate"
                    >Create Package</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card flat v-show="packageSummary">
        <v-card-text>
          <h4 class="dark-grey--text">Package Pricing</h4>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 px-3>
                <div v-if="((selectedLocationNetwork.packagesFno.setupFee != null) && (selectedLocationNetwork.packagesFno.setupFee != 0))">
                  <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.packagesFno.setupFee | currency }}</h4>
                </div>
                <div v-else>
                  <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.activationFeeAmount*(1+$VAT) | currency }}</h4>
                </div>
                <!-- <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.activationFeeAmount*(1+$VAT)|currency }}</h4> -->
                <v-text-field
                  id="addOnceOffPriceId"
                  v-model="editedItem.onceOffPriceVatInc"
                  label="*Total once off Costs to the end Client(incl. VAT)"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 px-3>
                <h4
                  v-if="selectedLocationNetwork.lineRentalIncluded===true"
                >Monthly Recurring VAS Fee Cost (incl. VAT): {{(packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)*(1+$VAT)|currency}}</h4>
                <h4
                  v-else
                >Monthly Recurring VAS Fee Cost (incl. VAT): {{packagesFnoById.packageBasePrice*(1+$VAT)|currency}}</h4>
                <v-text-field
                  id="addRecurringPriceId"
                  v-model="editedItem.recurringPriceVatInc"
                  label="*Total Monthly Price to end Client (incl. VAT)"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <h4 v-show="editedItem.onceOffPriceVatInc" class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) === 0"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-else-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <h4 v-show="editedItem.recurringPriceVatInc" class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) == 0"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn color="primary" round @click="pricingTerm=true;packageSummary=false">
                      <v-icon>keyboard_arrow_left</v-icon>Back
                    </v-btn>
                    <v-btn
                      color="primary"
                      round
                      @click="close;newDialog=false;packageSummary=false;basicInformation=false"
                    >Cancel</v-btn>
                    <v-btn id="addPackageSaveButtonId" color="primary" round @click="saveNew()">Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Edit Modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -------------------------------------------------------------------------------------------->
    <v-dialog persistent v-model="editDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Edit Package</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;pricingTerm=false;packageSummary=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;pricingTerm=true;packageSummary=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Package Details</v-tab>
          <v-tab
            v-show="!editedItem.attachPackageToTemplate"
            @click="basicInformation=false;pricingTerm=false;packageSummary=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Package Pricing</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat v-show="basicInformation">
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-text-field
                  class="px-2"
                  v-model="editedItem.name"
                  label="*Package Name"
                  hint="This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-textarea
                  class="px-2"
                  v-model="editedItem.description"
                  label="Package Description"
                  hint="Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
                  required
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Network"
                  :items="locationnetworks"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationNetworkId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-switch
                  v-model="editedItem.isActive"
                  label="Show Package on Application Page"
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center py-3>
                    <v-btn color="primary" round @click="close">Cancel</v-btn>
                    <v-btn color="primary" round @click="save">Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card v-show="pricingTerm">
        <v-card-text>
          <h4 class="dark-grey--text">Package Details</h4>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md6 v-if="editedItem.locationNetworkId">
                <v-switch
                  v-model="editedItem.attachPackageToTemplate"
                  label="Attach Package to Template"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs6 sm6 md6 v-if="editedItem.attachPackageToTemplate"></v-flex>
              <v-flex xs6 sm6 md6 v-if="editedItem.attachPackageToTemplate">
                <v-autocomplete
                  v-if="packagesIspTemplatesLocationNetwork.length>0"
                  clearable
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Select a Package Template"
                  :items="packagesIspTemplatesLocationNetwork"
                  return-object
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.packagesIspTemplate"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                v-if="!packagesIspTemplatesLocationNetwork.length>0&&editedItem.attachPackageToTemplate"
              >
                <span class="subheading">
                  No Package Templates match the speed profile of this package:
                  <b>{{editedItem.packagesFno.speedProfile.name}}</b>
                </span>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.speedProfile.name"
                  label="*Speed Profile"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.name"
                  label="*Package Name"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.description"
                  label="Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.onceOffPrice"
                  label="Once Off Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.recurringPrice"
                  label="Recurring Price Incl. VAT"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.term"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isFup"
                  label="Fair Usage Policy"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isCapped"
                  label="Capped"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'&&editedItem.packagesIspTemplate.isCapped"
              >
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.cappedAmountGb"
                  label="Term"
                  required
                  disabled
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-else-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'&&!editedItem.packagesIspTemplate.isCapped"
              ></v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-switch
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.isPromo"
                  label="Promotion"
                  required
                  disabled
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'&&editedItem.packagesIspTemplate.isPromo"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.promoDescription"
                  label="Promotion Description"
                  required
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex
                xs12
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'&&editedItem.packagesIspTemplate.hasSpecificTerms"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.packagesIspTemplate.specificTerms"
                  label="Specific Terms and Conditions"
                  disabled
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-else-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'&&!editedItem.packagesIspTemplate.isPromo"
              ></v-flex>
              <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <h4 class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-if="grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.onceOffPrice,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex
                xs6
                sm6
                md6
                v-if="editedItem.attachPackageToTemplate&&editedItem.packagesIspTemplate!==null&&typeof editedItem.packagesIspTemplate!=='undefined'"
              >
                <h4 class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) == 0"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.packagesIspTemplate.recurringPrice,packagesFnoById.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-text-field
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.name"
                  label="*Package Name: This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-textarea
                  class="px-2"
                  v-model="editedItem.description"
                  label="Package Description: Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
                  persistent-hint
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addPackageFnoId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*FNO Package"
                  :items="locationPackages"
                  item-text="packageCode"
                  item-value="id"
                  required
                  v-model="editedItem.packagesFnoId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addTermId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Contract Term"
                  :items="packageTerms"
                  v-model="editedItem.term"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-autocomplete
                  id="addRatioId"
                  clearable
                  hide-no-data
                  flat
                  v-on:keyup.enter="enterEvent"
                  color="primary"
                  label="*Layer 3 Contention Ratio"
                  :items="layer3ContentionRatios"
                  v-model="editedItem.layer3Contention"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate"></v-flex>

              <v-flex xs12 sm12 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isPromotion"
                  label="This is a promotional package"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    id="addDateId"
                    :value="this.editedItem.startDate"
                    slot="activator"
                    required
                    label="*Package Start Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-menu :close-on-content-click="false">
                  <v-text-field
                    v-show="editedItem.isPromotion"
                    :value="this.editedItem.endDate"
                    slot="activator"
                    label="Promotion End Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                v-show="editedItem.isPromotion&&!editedItem.attachPackageToTemplate"
              >
                <v-textarea
                  v-model="editedItem.promotionDescription"
                  label="Promotion Description"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isCapped"
                  label="Capped"
                  hint="Is this a Capped Package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm12 md4 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isShaped"
                  label="This package is shaped"
                  persistent-hint
                ></v-switch>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="!editedItem.attachPackageToTemplate">
                <v-switch
                  v-model="editedItem.isFup"
                  label="FUP"
                  hint="Do you have a Fair Usage Policy for this package?"
                  persistent-hint
                ></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-show="editedItem.isCapped&&!editedItem.attachPackageToTemplate"
              >
                <v-text-field
                  v-model="editedItem.cappedAmountGb"
                  label="CappedAmount"
                  hint="Capped amount in Gb"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md6
                v-if="!editedItem.attachPackageToTemplate"
              >
                <v-checkbox
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.hasSpecificTerms"
                  label="This package has specific Terms and Conditions"
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex
                xs12
                v-if="!editedItem.attachPackageToTemplate&&editedItem.hasSpecificTerms"
              >
                <v-textarea
                  id="addPackageNameId"
                  class="px-2"
                  v-model="editedItem.specificTerms"
                  label="Specific Terms and Conditions"
                  persistent-hint
                ></v-textarea>
              </v-flex>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn round color="primary" @click="close">Cancel</v-btn>
                    <v-btn round color="primary" @click="save">Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card flat v-show="packageSummary">
        <v-card-text>
          <h4 class="dark-grey--text">Package Pricing</h4>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 px-3>
                <div v-if="((selectedLocationNetwork.packagesFno.setupFee != null) && (selectedLocationNetwork.packagesFno.setupFee != 0))">
                  <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.packagesFno.setupFee | currency }}</h4>
                </div>
                <div v-else>
                  <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.activationFeeAmount*(1+$VAT) | currency }}</h4>
                </div>
                <!-- <h4>Data Activation Fee Cost (incl. VAT): {{ selectedLocationNetwork.activationFeeAmount*(1+$VAT) | currency }}</h4> -->
                <v-text-field
                  v-model="editedItem.onceOffPriceVatInc"
                  label="*Total once off Costs to the end Client(incl. VAT)"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 px-3>
                <h4
                  v-if="selectedLocationNetwork.lineRentalIncluded===true"
                >Monthly Recurring VAS Fee Cost (incl. VAT): {{(packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)*(1+$VAT)|currency}}</h4>
                <h4
                  v-else
                >Monthly Recurring VAS Fee Cost (incl. VAT): {{packagesFnoById.packageBasePrice*(1+$VAT)|currency}}</h4>
                <v-text-field
                  v-model="editedItem.recurringPriceVatInc"
                  label="*Total Monthly Price to end Client (incl. VAT)"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <h4 v-show="editedItem.onceOffPriceVatInc" class="dark-grey--text">
                  Once-off Gross Profit/Loss:
                  <h4
                    v-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) == 0"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>

                  <h4
                    v-if="grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.onceOffPriceVatInc,selectedLocationNetwork.activationFeeAmount)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex xs6 sm6 md6>
                <h4 v-show="editedItem.recurringPriceVatInc" class="dark-grey--text">
                  Recurring Gross Profit/Loss:
                  <h4
                    v-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) == 0"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) == 0"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) > 0"
                    class="green--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>

                  <h4
                    v-else-if="selectedLocationNetwork.lineRentalIncluded&&grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice-selectedLocationNetwork.residentialLineRentalValue)| currency}}</h4>
                  <h4
                    v-else-if="grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice) < 0"
                    class="red--text"
                  >{{grossProfit(editedItem.recurringPriceVatInc,packagesFnoById.packageBasePrice)| currency}}</h4>
                </h4>
              </v-flex>

              <v-flex 12 xs12 sm12 md>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn color="primary" round @click="close">Cancel</v-btn>
                    <v-btn color="primary" round @click="save">Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <!-- Peview Package Modal -->
    <v-dialog persistent v-model="previewPackageModal" max-width="250px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Preview Package Card</h1>
      </v-toolbar>

      <v-card flat color="white">
        <div v-if="previewPackageModal">
          <packagesispscards :cardsPerPage="1" :packagesIsps="packagePreviewCard"></packagesispscards>
        </div>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="previewPackageModal=false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <!-- <div v-if="displayContents('activeInternetPackages')">
      <v-data-table
        v-model="selected"
        :headers="headers"
        class="elevation-1"
        :search="search"
        :expand="expand"
        :loading="isloading"
        disable-initial-sort
        :items="activepackagesisps"
        item-key="id"
        align-center
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
           <td>
          <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="text-xs-center">
            <v-layout justify-center>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" medium @click="editItem(props.item)">edit</v-icon>
                </template>
                <span>Edit Package</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" medium @click="deleteItem(props.item)">delete</v-icon>
                </template>
                <span>Delete Package</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" medium @click="previewPackage(props.item)">remove_red_eye</v-icon>
                </template>
                <span>Preview Package Card</span>
              </v-tooltip>
            </v-layout>
          </td>
          <td class="text-xs-center">
            <v-icon
              v-if="!props.item.isVerified"
              color="red"
              medium
              @click="verifyItem(props.item)"
            >cancel</v-icon>
            <v-icon v-else color="tick" medium>check_circle_outline</v-icon>
          </td>
          <td class="text-xs-center">
            <v-icon
              v-if="props.item.isActive&&props.item.isVerified"
              medium
              color="tick"
              @click="showHideItem(props.item)"
            >check_circle_outline</v-icon>

            <v-tooltip top v-else-if="props.item.isActive&&!props.item.isVerified">
              <template v-slot:activator="{ on }">
                <v-icon
                  class="ml-4"
                  v-on="on"
                  medium
                  color="orange"
                  @click="showHideItem(props.item)"
                >error_outlined</v-icon>
              </template>
              <span>Verification Required</span>
            </v-tooltip>
            <v-icon v-else medium color="red" @click="showHideItem(props.item)">cancel</v-icon>
          </td>
          <td class="text-xs-center">
            <v-chip color="light-green white--text" v-if="props.item.packagesFno.isActive">Active</v-chip>
            <v-chip color="red white--text" v-else>Inactive</v-chip>
          </td>

      
          <td class="text-xs-center">{{props.item.packagesFnoId}}</td> 
          <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
          <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.packageCatType}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.packagesIspTemplateId!==null"
          >{{props.item.packagesIspTemplate.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{props.item.packagesFno.speedProfile.name}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.locationNetwork.lineRentalIncluded===true"
          >{{(props.item.packagesFno.packageBasePrice-props.item.locationNetwork.residentialLineRentalValue) | currency}}</td>
          <td class="text-xs-center" v-else>{{props.item.packagesFno.packageBasePrice | currency}}</td>

          
          <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="truncate">{{props.item.description}}</td>
          <td class="text-xs-center">{{props.item.onceOffPriceVatInc | currency}}</td>
          <td class="text-xs-center">{{props.item.recurringPriceVatInc | currency}}</td>
          <td
            class="text-xs-center"
            v-if="props.item.locationNetwork.lineRentalIncluded===true"
          >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice-props.item.locationNetwork.residentialLineRentalValue)| currency}}</td>
          <td
            class="text-xs-center"
            v-else
          >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice)| currency}}</td>
         
          <td class="text-xs-center" v-if="props.item.isPromotion">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>

          <td class="text-xs-center">{{props.item.promotionDescription}}</td>
          <td class="text-xs-center">{{props.item.term}}</td>
         
          <td class="text-xs-center" v-if="props.item.isCapped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>

          <td class="text-xs-center">{{props.item.cappedAmountGb}}</td>
          <td class="text-xs-center" v-if="props.item.isShaped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
         
          <td class="text-xs-center" v-if="props.item.isFup">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>

          <td class="text-xs-center">{{formatDate(props.item.startDate)}}</td>
          <td class="text-xs-center">{{formatDate(props.item.endDate)}}</td>

          <td
            class="text-xs-center"
            v-if="props.item.createdById!==null"
          >{{props.item.createdBy.name+' '+props.item.createdBy.surname}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            class="text-xs-center"
            v-if="props.item.lastModifiedById!==null"
          >{{props.item.lastModifiedBy.name+' '+props.item.lastModifiedBy.surname}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            class="text-xs-center"
            v-if="props.item.verifiedById!==null"
          >{{props.item.verifiedBy.name+' '+props.item.verifiedBy.surname}}</td>
          <td class="text-xs-center" v-else></td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div> -->

    <!-- Edit Package Group Modal -->
    <v-dialog persistent v-model="editPackageGroup" max-width="1250px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Edit Template Package Group: {{packagesIspCatObj.name}}</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs slider-color="primary">
          <v-tab
            @click="packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false;packageTemplateGroupAttachedNetworks=false"
          >Information</v-tab>
          <v-tab
            @click="packageTemplateGroupInfo=false;packageTemplateGroupAttachedPackages=true;packageTemplateGroupAttachedNetworks=false"
          >Attached Package Template's</v-tab>
          <v-tab
            @click="packageTemplateGroupInfo=false;packageTemplateGroupAttachedPackages=false;packageTemplateGroupAttachedNetworks=true"
          >Attached Network's</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat color="white" v-if="packageTemplateGroupInfo">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field v-model="packagesIspCatObj.name" persistent-hint label="*Group Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-textarea
                v-model="packagesIspCatObj.description"
                persistent-hint
                label="Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field v-model="packagesIspCatObj.code" persistent-hint label="Group Code"></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 sm6 md6>
               <v-select
               :items="packagetypes"
                  v-model="packagesIspCatObj.packageCatType"
                  persistent-hint
                  label="Group Type"
                >
               </v-select>
            </v-flex>-->
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="editPackageGroup=false,packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false,packageTemplateGroupAttachedNetworks=false, packagesIspCatObj={}"
              >Cancel</v-btn>
              <v-btn
                color="primary"
                round
                @click="savePackageGroup(),packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false,packageTemplateGroupAttachedNetworks=false"
              >Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
      <!-- Associated Package Templates -->
      <v-card flat color="white" v-if="packageTemplateGroupAttachedPackages">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-btn
                round
                color="primary"
                @click="viewPackageTemplateModal=true"
              >Add Template to Group</v-btn>
            </v-toolbar>
            <v-data-table
              :headers="packagesisptemplatesHeadersReduced"
              class="elevation-1"
              :search="search"
              :expand="expand"
              :loading="isloading"
              disable-initial-sort
              :items="packagesisptemplatesArray"
              item-key="id"
              align-center
              :rows-per-page-items="[5, 10, 25, 50, 100, 250]"
            >
              <template v-slot:items="props">
                <td class="justify-center layout px-0 py-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        medium
                        class="mr-1"
                        color="red"
                        @click="removeTemplatePackageFromGroup(props.item)"
                      >remove_circle</v-icon>
                    </template>
                    <span>Remove Package</span>
                  </v-tooltip>
                </td>

                <!-- FNO -->
                <!-- <td class="text-xs-center">{{props.item.packagesFnoId}}</td> -->
                <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.recurringPrice|currency}}</td>
                <td class="text-xs-center">{{props.item.onceOffPrice|currency}}</td>
                <td class="text-xs-center" v-if="props.item.isFup">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isShaped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isCapped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>

                <td class="text-xs-center">{{props.item.term}}</td>
              </template>
              <template
                v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
            </v-data-table>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="editPackageGroup=false,packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false, packagesIspCatObj={}"
              >Cancel</v-btn>
              <v-btn
                color="primary"
                round
                @click="savePackageGroup(),packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false"
              >Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>

      <!-- Associated Location Networks -->
      <v-card flat color="white" v-if="packageTemplateGroupAttachedNetworks">
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="viewLocationNetworkModal=true">Add Network to Group</v-btn>
        </v-toolbar>
        <v-data-table
          :headers="locationNetworkHeaders"
          class="elevation-1"
          :search="search"
          :expand="expand"
          :loading="isloading"
          disable-initial-sort
          :items="packageTemplateLocationNetworks"
          item-key="id"
          align-center
          :rows-per-page-items="[5, 10, 25, 50, 100, 250]"
        >
          <template v-slot:items="props">
            <td class="justify-center layout px-0 py-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-1"
                    color="red"
                    @click="removeNetworkFromGroup(props.item)"
                  >remove_circle</v-icon>
                </template>
                <span>Remove Network</span>
              </v-tooltip>
            </td>
            <td v-if="props.item.networkStatus==='Live'" class="text-xs-center">
              <v-chip small :class="`Live white--text caption my-2`">Live</v-chip>
            </td>
            <td v-if="props.item.networkStatus==='In Progress'" class="text-xs-center">
              <v-chip small :class="`Progress white--text caption my-2`">In Progress</v-chip>
            </td>
            <td v-if="props.item.networkStatus==='Planned'" class="text-xs-center">
              <v-chip small :class="`planned white--text caption my-2`">Planned</v-chip>
            </td>
            <td v-if="props.item.networkStatus===null" class="text-xs-center"></td>
            <td class="text-xs-center">{{props.item.name}}</td>
          </template>
          <template
            v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
        </v-data-table>

        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="editPackageGroup=false,packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false;packageTemplateGroupAttachedNetworks=false, packagesIspCatObj={}"
              >Cancel</v-btn>
              <v-btn
                color="primary"
                round
                @click="savePackageGroup(),packageTemplateGroupInfo=true;packageTemplateGroupAttachedPackages=false;packageTemplateGroupAttachedNetworks=false"
              >Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>

    <!-- Add Template Package to Group -->
    <v-dialog persistent max-width="1250px" v-model="viewPackageTemplateModal">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Templates to Group</h1>
      </v-toolbar>
      <v-card flat color="white">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-toolbar flat color="white" v-if="selectedTemplates.length>0">
              <v-btn
                round
                color="primary"
                @click="bulkAddTemplatesToGroup();viewPackageTemplateModal=false;editPackageGroup=false"
              >Add Selected to Group</v-btn>
            </v-toolbar>
            <v-data-table
              v-model="selectedTemplates"
              :headers="packagesisptemplatesHeadersReducedModal"
              class="elevation-1"
              :search="search"
              :expand="expand"
              :loading="isloading"
              select-all
              disable-initial-sort
              :items="selectablePackagesIspTemplates"
              item-key="id"
              align-center
              :rows-per-page-items="[25, 50, 100, 250]"
            >
              <template v-slot:items="props">
                <td>
                  <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
                </td>
                <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.recurringPrice|currency}}</td>
                <td class="text-xs-center">{{props.item.onceOffPrice|currency}}</td>
                <td class="text-xs-center" v-if="props.item.isFup">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isShaped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isCapped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>

                <td class="text-xs-center">{{props.item.term}}</td>
              </template>
              <template
                v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
            </v-data-table>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="viewPackageTemplateModal=false">Cancel</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>

    <!-- Add Networks to Group -->
    <v-dialog persistent max-width="750px" v-model="viewLocationNetworkModal">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Networks to Group</h1>
      </v-toolbar>
      <v-card flat color="white">
        <v-toolbar flat color="white">
          <v-text-field label="Search" v-model="locationNetworkSearch"></v-text-field>
          <v-btn
            round
            color="primary"
            v-if="selectedNetworks.length>0"
            @click="bulkAddNetworksToGroup();viewLocationNetworkModal=false;packageTemplateGroupAttachedNetworks=false;editPackageGroup=false"
          >Add Selected to Group</v-btn>
        </v-toolbar>

        <v-data-table
          v-model="selectedNetworks"
          :headers="locationNetworkHeadersReduced"
          class="elevation-1"
          :search="locationNetworkSearch"
          :expand="expand"
          :loading="isloading"
          select-all
          disable-initial-sort
          :items="locationnetworks"
          item-key="id"
          align-center
          :rows-per-page-items="[5, 10, 25, 50, 100, 250]"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td v-if="props.item.networkStatus==='Live'" class="text-xs-center">
              <v-chip small :class="`Live white--text caption my-2`">Live</v-chip>
            </td>
            <td v-if="props.item.networkStatus==='In Progress'" class="text-xs-center">
              <v-chip small :class="`Progress white--text caption my-2`">In Progress</v-chip>
            </td>
            <td v-if="props.item.networkStatus==='Planned'" class="text-xs-center">
              <v-chip small :class="`planned white--text caption my-2`">Planned</v-chip>
            </td>
            <td v-if="props.item.networkStatus===null" class="text-xs-center"></td>
            <td class="text-xs-center">{{props.item.name}}</td>
          </template>
          <template
            v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
        </v-data-table>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="viewLocationNetworkModal=false">Cancel</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>

    <!-- Add Package Group Modal -->
    <v-dialog persistent v-model="addPackageGroup" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Template Package Group</h1>
      </v-toolbar>
      <v-card flat color="white">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field v-model="packagesIspCatObj.name" persistent-hint label="*Group Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-textarea
                v-model="packagesIspCatObj.description"
                persistent-hint
                label="Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field v-model="packagesIspCatObj.code" persistent-hint label="Group Code"></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 sm6 md6>
               <v-select
               :items="packagetypes"
                  v-model="packagesIspCatObj.packageCatType"
                  persistent-hint
                  label="Group Type"
                >
               </v-select>
            </v-flex>-->
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="addPackageGroup=false">Cancel</v-btn>
              <v-btn color="primary" round @click="saveNewPackageGroup">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white" v-if="packageCategories">
      <v-spacer></v-spacer>
      <v-btn round color="primary" @click="addPackageGroup=true">Add Group</v-btn>
    </v-toolbar>
    <v-data-table
      v-show="packageCategories"
      :headers="packagesispcatsHeaders"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :loading="isloading"
      disable-initial-sort
      :items="packagesispcats"
      item-key="id"
      align-center
      :rows-per-page-items="[25, 50, 100, 250]"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0 py-3">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" medium class="mr-1" @click="editPackageGroupItem(props.item)">edit</v-icon>
            </template>
            <span>Edit Package</span>
          </v-tooltip>
        </td>

        <!-- FNO -->
        <!-- <td class="text-xs-center">{{props.item.packagesFnoId}}</td> -->
        <td class="text-xs-center">{{props.item.customer.name}}</td>
        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">{{props.item.code}}</td>
        <td class="truncate">{{props.item.description}}</td>
        <!-- <td class="text-xs-center">{{props.item.packageCatType}}</td> -->
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <!-- Edit Package Group Modal -->
    <v-dialog persistent v-model="editPackageTemplate" max-width="1250px">
      <v-toolbar flat class="primary">
        <h1
          class="headline white--text"
        >Edit Template Package Group: {{packagesIspTemplateObj.name}}</h1>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-tabs slider-color="primary">
          <v-tab
            @click="packageTemplateInfo=true;packageTemplateAttachedPackages=false"
          >Package Information</v-tab>
          <v-tab
            @click="packageTemplateInfo=false;packageTemplateAttachedPackages=true"
          >Attached Data Packages</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat color="white" v-if="packageTemplateInfo">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                id="filterSpeedId"
                clearable
                v-model="packagesIspTemplateObj.speedProfileId"
                :items="speedprofiles"
                hide-no-data
                flat
                color="primary"
                label="Speed"
                item-text="name"
                item-value="id"
                disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.name"
                persistent-hint
                label="*Template Package Name"
                hint="This is the title of your package card. Be sure to include your ISP name and speed profile. E.g. DEMOISP 20/10Mbps"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-textarea
                v-model="packagesIspTemplateObj.description"
                persistent-hint
                label="Package Description"
                hint="Tell customers about this package and why they should select it. Are there any additional benefits? Or do you perhaps have FUP, throttling, shaping, etc.?"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.recurringPrice"
                persistent-hint
                label="Recurring Price incl. VAT"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.onceOffPrice"
                persistent-hint
                label="Once Off Price incl. VAT"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch
                v-model="packagesIspTemplateObj.isFup"
                persistent-hint
                label="Fair Usage Policy"
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isShaped" persistent-hint label="Shaped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isCapped" persistent-hint label="Capped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="packagesIspTemplateObj.isCapped">
              <v-text-field
                type="number"
                v-model="packagesIspTemplateObj.cappedAmountGb"
                persistent-hint
                label="Capped Amount(Gb)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isPromo" persistent-hint label="Promotion"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="packagesIspTemplateObj.isPromo">
              <v-textarea
                v-model="packagesIspTemplateObj.promoDescription"
                persistent-hint
                label="Promotion Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                clearable
                hide-no-data
                flat
                color="primary"
                label="*Contract Term"
                :items="packageTerms"
                v-model="packagesIspTemplateObj.term"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-checkbox
                color="primary"
                label="This package has specific T's & C's"
                v-model="packagesIspTemplateObj.hasSpecificTerms"
              ></v-checkbox>
             </v-flex>
               <v-flex xs12 v-if="packagesIspTemplateObj.hasSpecificTerms">
              <v-textarea
                color="primary"
                label="Please specify the specific terms & conditions"
                v-model="packagesIspTemplateObj.specificTerms"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="editPackageTemplate=false, packagesIspTemplateObj={}"
              >Cancel</v-btn>
              <v-btn color="primary" round @click="savePackageTemplate()">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>

      <v-card flat color="white" v-if="packageTemplateAttachedPackages">
        <v-container grid-list-xs>
          <v-layout wrap>
            <!-- <v-toolbar flat color="white" v-if="selectedTemplates.length>0"><v-btn round color="primary" @click="bulkAddTemplatesToGroup();viewPackageTemplateModal=false;editPackageGroup=false">Add Selected to Group</v-btn> </v-toolbar> -->
            <v-data-table
              :headers="packagesIspTemplateAttachedPackagesHeaders"
              class="elevation-1"
              :search="search"
              :expand="expand"
              :loading="isloading"
              disable-initial-sort
              :items="packagesIspTemplateAttachedPackages"
              item-key="id"
              align-center
              :rows-per-page-items="[5, 10, 25, 50, 100, 250]"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-layout justify-center>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          medium
                          class="mr-1"
                          color="red"
                          @click="removePackageFromTemplate(props.item)"
                        >remove_circle</v-icon>
                      </template>
                      <span>Unlink Package</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" medium class="mr-1" @click="deleteItem(props.item)">delete</v-icon>
                      </template>
                      <span>Delete Package</span>
                    </v-tooltip>
                  </v-layout>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    v-if="!props.item.isVerified"
                    color="red"
                    medium
                    @click="verifyItem(props.item);editPackageTemplateItem(packagesIspTemplateObj)"
                  >cancel</v-icon>
                  <v-icon v-else color="primary" medium>check_circle_outline</v-icon>
                </td>
                <td class="text-xs-center">
                  <v-layout justify-center>
                    <v-icon
                      v-if="props.item.isActive&&props.item.isVerified"
                      medium
                      color="primary"
                      @click="showHideItem(props.item);editPackageTemplateItem(packagesIspTemplateObj)"
                    >check_circle_outline</v-icon>

                    <v-tooltip top v-else-if="props.item.isActive&&!props.item.isVerified">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="ml-4"
                          v-on="on"
                          medium
                          @click="showHideItem(props.item);editPackageTemplateItem(packagesIspTemplateObj)"
                          color="orange"
                        >error_outlined</v-icon>
                      </template>
                      <span>Verification Required</span>
                    </v-tooltip>
                    <v-icon
                      v-else
                      medium
                      color="red"
                      @click="showHideItem(props.item);editPackageTemplateItem(packagesIspTemplateObj)"
                    >cancel</v-icon>
                  </v-layout>
                </td>
                <td class="text-xs-center">{{props.item.locationNetwork.name}}</td>
                <td class="text-xs-center">{{props.item.packagesFno.packageBasePrice|currency}}</td>
                <td class="text-xs-center">{{props.item.recurringPriceVatInc|currency}}</td>
                <td class="text-xs-center">{{props.item.onceOffPriceVatInc|currency}}</td>
                <td
                  class="text-xs-center"
                >{{grossProfit(props.item.recurringPriceVatInc,props.item.packagesFno.packageBasePrice)| currency}}</td>
                <td class="text-xs-center">{{props.item.term}}</td>
              </template>
              <template
                v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
            </v-data-table>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                round
                @click="editPackageTemplate=false,packageTemplateAttachedPackages=false, packagesIspTemplateObj={}"
              >Cancel</v-btn>
              <v-btn
                color="primary"
                round
                @click="savePackageTemplate(),editPackageTemplate=false,packageTemplateAttachedPackages=false"
              >Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>

    <!-- Add Package Template Modal -->
    <v-dialog persistent v-model="addPackageTemplate" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Template Package</h1>
      </v-toolbar>
      <v-card flat color="white">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                id="filterSpeedId"
                clearable
                v-model="packagesIspTemplateObj.speedProfileId"
                :items="speedprofiles"
                hide-no-data
                flat
                color="primary"
                label="Speed"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.name"
                persistent-hint
                label="*Template Package Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="packagesIspTemplateObj.description"
                persistent-hint
                label="Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.recurringPrice"
                persistent-hint
                label="Recurring Price incl. VAT"
                type="number"
                step="0.01"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="packagesIspTemplateObj.onceOffPrice"
                persistent-hint
                label="Once Off Price incl. VAT"
                type="number"
                step="0.01"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch
                v-model="packagesIspTemplateObj.isFup"
                persistent-hint
                label="Fair Usage Policy"
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isShaped" persistent-hint label="Shaped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isCapped" persistent-hint label="Capped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="packagesIspTemplateObj.isCapped">
              <v-text-field
                type="number"
                v-model="packagesIspTemplateObj.cappedAmountGb"
                persistent-hint
                label="Capped Amount(Gb)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="packagesIspTemplateObj.isPromo" persistent-hint label="Promotion"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="packagesIspTemplateObj.isPromo">
              <v-textarea
                v-model="packagesIspTemplateObj.promoDescription"
                persistent-hint
                label="Promotion Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                clearable
                hide-no-data
                flat
                color="primary"
                label="*Contract Term"
                :items="packageTerms"
                v-model="packagesIspTemplateObj.term"
              ></v-autocomplete>
            </v-flex>
             <v-flex xs12 sm6 md6>
              <v-checkbox
                color="primary"
                label="This package has specific T's & C's"
                v-model="packagesIspTemplateObj.hasSpecificTerms"
              ></v-checkbox>
             </v-flex>
               <v-flex xs12 v-if="packagesIspTemplateObj.hasSpecificTerms">
              <v-textarea
                color="primary"
                label="Please specify the specific terms & conditions"
                v-model="packagesIspTemplateObj.specificTerms"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="addPackageTemplate=false">Cancel</v-btn>
              <v-btn color="primary" round @click="saveNewPackageTemplate()">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
    <div v-if="displayContents('packagesOverview')">
      <!-- <v-card flat color="white" v-if="layertwousage.length>0">
        <v-container grid-list-xs>
          <v-layout wrap justify-center align-center>
           
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-card color="white" hover>
                  <h2
                    justify-center
                    class="subheading font-weight-bold mt-1 grey--text text-xs-center"
                  >Layer Two Usage History:</h2>
                  <v-card-text>
                    <v-flex>
                      <v-layout justify-left text-xs-center>
                        <v-flex xs4>
                          <h3 class="primary--text">Billed From:</h3>
                        </v-flex>
                       
                        <v-flex xs4>
                          <h3 class="primary--text">Billed To:</h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="primary--text">Usage:</h3>
                        </v-flex>
                 
                      </v-layout>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-container grid-list-xs>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm12
                          md12
                          v-for="usage in layertwousage"
                          :key="usage.bill_hist_id"
                        >
                          <v-layout text-xs-center>
                            <v-flex xs4>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >{{formatDate(usage.bill_datefrom)}}</h2>
                            </v-flex>
                            <v-flex xs4 text-xs-center>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >{{formatDate(usage.updated)}}</h2>
                            </v-flex>
                            <v-flex xs4 text-xs-center>
                              <h2
                                class="subheading grey--text font-weight-bold"
                              >{{(Math.round(usage.rate_95th/10000)/100)}} Mbps</h2>
                            </v-flex>
                         
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card> -->
<v-dialog persistent v-model="addNewNetworkPackages" max-width="900px"> 
<v-card>
  <v-toolbar flat color="primary">
        <h3 class='headline white--text'>Add Packages</h3>
        </v-toolbar>
        <v-card-text>
           <h2  v-if="!filteredPackages" class='grey--text'>Please create package templates</h2>
      <v-data-table
        v-if="filteredPackages&&filteredPackages.length>0"
        :headers="packagesisptemplatesHeadersReducedModal"
        class="elevation-1"
        :items="filteredPackages"
        :rows-per-page-items="[25, 50, 100, 250]"
        v-model="filteredPackagesTable"
        item-key="id"
        align-center
        select-all
      >
        <template v-slot:items="props">
          <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
         <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.recurringPrice|currency}}</td>
                <td class="text-xs-center">{{props.item.onceOffPrice|currency}}</td>
                <td class="text-xs-center" v-if="props.item.isFup">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isShaped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>
                <td class="text-xs-center" v-if="props.item.isCapped">
                  <v-icon color="green">done</v-icon>
                </td>
                <td class="text-xs-center" v-else>
                  <v-icon color="red">not_interested</v-icon>
                </td>

                <td class="text-xs-center">{{props.item.term}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
      <h3 class="grey--text" v-else>You don't have any package templates that match the available speeds.</h3>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
           <!-- <v-btn v-if="filteredPackagesTable.length>0" round color="primary" @click="addNewNetworkPackages=false;">NEXT</v-btn> -->
            <v-btn v-if="filteredPackages&&filteredPackages.length>0"  round color="primary" @click="addNewNetworkPackages=false;">Cancel</v-btn>
            <v-btn round color="primary" v-if="filteredPackages&&filteredPackages.length>0"  @click="savePackages()">Save</v-btn>
            <v-btn v-if="!filteredPackages||filteredPackages.length==0" round color="primary" @click="addNewNetworkPackages=false;">Okay</v-btn>
           <!-- <v-btn v-else disabled round color="primary">NEXT</v-btn> -->
          </v-layout>
        </v-card-actions>

</v-card>
</v-dialog>
      <v-card flat color="white">
       <h2 v-if="newNetworks.length>0" class="grey--text">New Networks</h2>
        <v-container v-if="newNetworks.length>0" :key="key" fluid grid-list-md >
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-for="network in newNetworks" :key="network.id">
              <v-card
                hover
                mt-2
                :tile="tile"
              >
                <v-toolbar flat color="grey">
                  <v-toolbar-title class="white--text text-xs-center">{{network.name}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn  small @click="addPackageTemplates(network)" v-if="authCreate($store.state.currentRoute)" round color="primary" ><v-icon small>share</v-icon> Link to Package Templates</v-btn>
                   <!-- <v-btn  round color="primary" @click="addPackageTemplates(network)" ><v-icon>add_circle_outline</v-icon>  Packages</v-btn> -->
                </v-toolbar>
                <v-card-text>
                  <v-container 
                @click="packageSummaryredirect(network.id)" grid-list-xs>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 text-xs-left>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold">Status:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3 class="grey--text font-weight-light">
                              <v-chip
                                small
                                v-if="network.networkStatus==='Live'"
                                color="light-green"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                              <v-chip
                                small
                                v-else-if="network.networkStatus==='Planned'"
                                color="light-blue"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                              <v-chip
                                small
                                v-else-if="network.networkStatus==='In Progress'"
                                color="orange"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2
                              class="subheading grey--text font-weight-bold"
                            >Available FNO Packages:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.availablePackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold">
                              Unused FNO Packages:
                              <v-icon color="orange" v-if="network.unusedPackages.length>0">warning</v-icon>
                            </h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.unusedPackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2
                              class="subheading grey--text font-weight-bold"
                            >Current Number of Live Packages:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.currentPackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
    
      <h2 class="grey--text">Active Networks</h2>
  
         <v-container  :key="key"  fluid grid-list-md >
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-for="network in activeNetworks" :key="network.id">
              <v-card
                hover
                mt-2
                :tile="tile"
                @click="packageSummaryredirect(network.id)"
              >
                <v-toolbar flat color="grey">
                  <v-toolbar-title class="white--text text-xs-center">{{network.name}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-container grid-list-xs>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 text-xs-left>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold">Status:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3 class="grey--text font-weight-light">
                              <v-chip
                                small
                                v-if="network.networkStatus==='Live'"
                                color="light-green"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                              <v-chip
                                small
                                v-else-if="network.networkStatus==='Planned'"
                                color="light-blue"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                              <v-chip
                                small
                                v-else-if="network.networkStatus==='In Progress'"
                                color="orange"
                                class="white--text"
                              >{{network.networkStatus}}</v-chip>
                            </h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2
                              class="subheading grey--text font-weight-bold"
                            >Available FNO Packages:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.availablePackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold">
                              Unused FNO Packages:
                              <v-icon color="orange" v-if="network.unusedPackages.length>0">warning</v-icon>
                            </h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.unusedPackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                        <v-layout justify-left>
                          <v-flex xs8>
                            <h2
                              class="subheading grey--text font-weight-bold"
                            >Current Number of Live Packages:</h2>
                          </v-flex>
                          <v-flex xs4>
                            <h3
                              class="grey--text font-weight-light"
                            >{{network.currentPackages.length}}</h3>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </div>
    <v-toolbar flat color="white" v-if="displayContents('packageTemplates')">
      <v-spacer></v-spacer>
      <v-btn round color="primary" @click="addPackageTemplateCheck()">Add Package Template</v-btn>
    </v-toolbar>
    <div v-if="displayContents('packageTemplates')">
      <v-data-table
        v-show="packageTemplates"
        :headers="packagesisptemplatesHeaders"
        class="elevation-1"
        :search="search"
        :expand="expand"
        :loading="isloading"
        disable-initial-sort
        :items="packagesisptemplates"
        item-key="id"
        align-center
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout justify-center>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-1"
                    @click="editPackageTemplateItem(props.item);packageTemplateInfo=true;editPackageTemplate=true"
                  >edit</v-icon>
                </template>
                <span>Edit Package Template</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-1"
                    @click="deletePackageTemplateItem(props.item)"
                  >delete</v-icon>
                </template>
                <span>Delete Package Template</span>
              </v-tooltip>
            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="truncate">{{props.item.description}}</td>
          <td class="text-xs-center">{{props.item.recurringPrice|currency}}</td>
          <td class="text-xs-center">{{props.item.onceOffPrice|currency}}</td>
          <td class="text-xs-center" v-if="props.item.isFup">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center" v-if="props.item.isShaped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center" v-if="props.item.isCapped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.cappedAmountGb}}</td>
          <td class="text-xs-center" v-if="props.item.isPromo">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.promoDescription}}</td>
          <td class="text-xs-center">{{props.item.term}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import VueCurrencyFilter from "vue-currency-filter";
import dateformat from "dateformat";
import Loading from "vue-loading-overlay";
import PackagesIspsCards from "@/components/PackagesIspsCards.vue";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";
// import VueFroala from 'vue-froala-wysiwyg';

export default {
  props: [
    "locationnetworks",
    "packagesisps",
    "activepackagesisps",
    "archivedpackagesisps",
    "unregisteredpackagesisps",
    "packagesFno",
    "packagesIsp",
    "speedprofiles",
    "packagetypes",
    "isloading",
    "packagesispcats",
    "packagesisptemplates",
    "filterspeeds",
    "customerid",
    "organisations",
    "packageOverview",
    "layertwousage"
  ],
  components: {
    "vue-currency-filter": VueCurrencyFilter,
    loading: Loading,
    packagesispscards: PackagesIspsCards,
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart
  },

  data() {
    return {
      packagesFnoId:null,
      currentLocationNetworkId:null,
      filteredPackagesTable:[],
      filteredPackages:[],
      addNewNetworkPackages:false,
      activeNetworks:[],
      newNetworks:[],
      packageTerms: ["month-to-month", "6 month", "12 month", "24 month"],
      date: new Date().toISOString().substr(0, 10),
      previewPackageModal: false,
      clearFilters: false,
      addPackageGroup: false,
      key: 0,
      tile: true,
      packageTemplateGroupInfo: false,
      packageTemplateGroupAttachedPackages: false,
      packagesIspTemplatesLocationNetwork: [],
      packageTemplates: true,
      viewPackageTemplateModal: false,
      packageTemplateGroupAttachedNetworks: false,
      packagesLocationNetworkArray: [],
      viewLocationNetworkModal: false,
      selectedNetworks: [],
      locationNetworkSearch: "",
      packagesIspCatLocationNetworkArray: [],
      packagesIspTemplateAttachedPackages: [],
      packageTemplateInfo: false,
      packageTemplateAttachedPackages: false,
      textEditor: "",
      textEditorConfig: {
        placeholderText: "Enter your package description",
        charCounterCount: true
      },
      packagesIspTemplateObj: {
        id: null,
        name: "",
        description: "",
        isCapped: false,
        isFup: false,
        isPromo: false,
        isShaped: false,
        recurringPrice: 0,
        onceOffPrice: 0
      },
      tabs: [
        { name: "packagesOverview", displayName: "Packages Overview" },
        { name: "packageTemplates", displayName: "Package Templates" }
      ],
      addPackageTemplate: false,
      editPackageTemplate: false,
      packageCategories: false,
      packagePreviewCard: [],
      packagesisptemplatesArray: [],
      selectablePackagesIspTemplates: [],
      packagesIspCatPackagesIspTemplatesArray: [],
      editPackageGroup: false,
      speedProfileTemplates: [],
      filterNetwork: null,
      filterIsp: null,
      filterSpeed: null,
      filterPackageType: null,
      filterCategory: null,
      filterUnregisteredPackages: false,
      filterArchivedPackages: false,
      filterActivePackages: false,
      selected: [],
      selectedTemplates: [],
      loadingPackages: this.isloading,
      menu: false,
      modal: false,
      isLoading: false,
      menu2: false,
      summary: false,
      basicInformation: false,
      basicInfo: false,
      activeInternetPackages: false,
      archivedPackages: false,
      unregisteredPackages: false,
      registerDialogToolbar: false,
      registerDialog: false,
      pricingTerm: false,
      packageSummary: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      editDialog: false,
      pagination: {},
      pagination1: {},
      pagination2: {},
      pagination3: {},
      activeTabName: "",
      speedErrorMessage: false,
      layer3ContentionRatios: [
        "1:1",
        "1:2",
        "1:4",
        "1:10",
        "1:20",
        "1:50",
        "1:100",
        "1:150"
      ],
      headersUnregistered: [
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packagesFnoCat.packageCatType"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packagesFno.packagesFnoCat.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packagesFno.packageBasePrice"
        },
        {
          text: "Internet Service Provider",
          align: "center",
          value: "customer.name"
        }
      ],
      packagesIspTemplateAttachedPackagesHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified"
        },
        {
          text: "Visible on Application",
          align: "center",
          value: "isActive"
        },

        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        // {
        //   text: "FNO Package",
        //   align: "center",
        //   value: "packagesFnoId"
        // },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packageBasePrice"
        },
        // {
        //   text: "ISPId",
        //   align: "center",
        //   value: "customerId"
        // },
        {
          text: "ISP NRC inc VAT",
          align: "centre",
          value: "recurringPriceVatInc"
        },
        {
          text: "ISP MRC inc VAT",
          align: "center",
          value: "onceOffPriceVatInc"
        },
        {
          text: "ISP Gross Profit",
          align: "center",
          sortable: false
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      locationNetworkHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Network Name",
          align: "center",
          value: "name"
        }
      ],
      locationNetworkHeadersReduced: [
        {
          text: "Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Network Name",
          align: "center",
          value: "name"
        }
      ],
      packagesisptemplatesHeadersReduced: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesisptemplatesHeadersReducedModal: [
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesisptemplatesHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Capped Amount (Gb)",
          align: "center",
          value: "cappedAmountGb"
        },
        {
          text: "Promotion",
          align: "center",
          value: "isPromo"
        },
        {
          text: "Promotion Description",
          align: "center",
          value: "promoDescription"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
      packagesispcatsHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Customer Name",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Group Name",
          align: "center",
          value: "name"
        },
        {
          text: "Code",
          align: "center",
          value: "code"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
        // {
        //   text: "FNO Package",
        //   align: "center",
        //   value: "packagesFnoId"
        // },
        // {
        //   text: "Group Type",
        //   align: "center",
        //   value: "packageCatType"
        // }
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Verified",
          align: "center",
          value: "isVerified"
        },
        {
          text: "Visible on Application",
          align: "center",
          value: "isActive"
        },
        {
          text: "FNO Package Status",
          align: "center",
          value: "packagesFno.isActive"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        // {
        //   text: "FNO Package",
        //   align: "center",
        //   value: "packagesFnoId"
        // },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packagesFnoCat.packageCatType"
        },
        {
          text: "Linked Package Template",
          align: "center",
          value: "packagesIspTemplate.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "FNO Price ex Vat",
          align: "center",
          value: "packageBasePrice"
        },
        // {
        //   text: "ISPId",
        //   align: "center",
        //   value: "customerId"
        // },
        {
          text: "Internet Service Provider",
          align: "center",
          value: "customer.name"
        },
        {
          text: "ISP Package",
          align: "center",
          value: "name"
        },
        {
          text: " ISP Package Description",
          align: "center",
          value: "description",
          sortable: false
        },
        {
          text: "ISP NRC inc VAT",
          align: "right",
          sortable: false
        },
        {
          text: "ISP MRC inc VAT",
          align: "center",
          sortable: false
        },
        {
          text: "ISP Gross Profit",
          align: "center",
          sortable: false
        },
        {
          text: "Promotion",
          align: "center",
          value: "isPromotion"
        },
        {
          text: "Promo Description",
          align: "center",
          value: "promotionDescription",
          sortable: false
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Capped Amount (Gb)",
          align: "center",
          value: "cappedAmountGb"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Fair Usage Policy",
          align: "center",
          value: "isFup"
        },
        {
          text: "Start Date",
          align: "center",
          value: "startDate"
        },
        {
          text: "End Date",
          align: "center",
          value: "endDate"
        },

        // {
        //   text: "isDeleted",
        //   align: "center",
        //   value: "isDeleted"
        // },

        {
          text: "Created",
          align: "center",
          value: "createdBy.name"
        },
        {
          text: "Last Modified",
          align: "center",
          value: "lastModifiedBy.name"
        },
        {
          text: "Verified By",
          align: "center",
          value: "verifiedBy.name"
        }
      ],
      summaryHeaders: [
        {
          text: "ISP",
          align: "center",
          value: "customer.name"
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name"
        },
        {
          text: "Package Type",
          align: "center",
          value: "packagesFno.packageCatType.name"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps"
        },
        {
          text: "ISP Package",
          align: "center",
          value: "name"
        },
        {
          text: "Term",
          align: "center",
          value: "term",
          sortable: false
        },
        {
          text: "Recurring Gross Profit/Loss",
          align: "center",
          sortable: false
        }
      ],
      activePackagesIsps: [],
      archivedPackagesIsps: [],
      unregisteredPackagesIsps: [],
      packagesFnoById: [],
      customers: [],
      selectedLocationNetwork: [],
      packagesFnos: [],
      locationNetworks: [],
      locationPackages: [],
      locationPackagesId: [],
      packagesIspCatObj: {},
      layer2Graph: {},
      layer2GraphOptions: {},
      graphLoaded: false,
      editedIndex: -1,
      editedItem: {
        name: "",
        description: "",
        locationNetwork: "",
        locationNetworkId: "",
        onceOffPriceVatInc: "",
        recurringPriceVatInc: "",
        layer3Contention: "",
        isPromotion: "",
        term: "",
        fupUrl: "",
        isShaped: false,
        isCapped: "",
        cappedAmountGb: 0,
        isFup: false,
        startDate: "",
        endDate: "",
        packagesFnoId: "",
        packagesFno: "",
        packageCode: "",
        promotionDescription: "",
        customerId: "",
        customer: "",
        isVerified: null,
        createdById: null,
        lastModifiedById: null,
        verifiedById: null,
        attachPackageToTemplate: false,
        packagesIspTemplate: null,
        hasSpecificTerms: false,
        specificTerms: '',
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        description: "",
        locationNetwork: "",
        locationNetworkId: "",
        onceOffPriceVatInc: "",
        recurringPriceVatInc: "",
        layer3Contention: "",
        isPromotion: "",
        term: "",
        fupUrl: "",
        isShaped: false,
        isCapped: "",
        cappedAmountGb: 0,
        isFup: false,
        startDate: "",
        endDate: "",
        packagesFnoId: "",
        packagesFno: {
          name: "",
          speedProfile: {
            name: "",
            contentionRatio: ""
          }
        },
        packageCode: "",
        promotionDescription: "",
        customerId: "",
        customer: "",
        isVerified: null,
        createdById: null,
        lastModifiedById: null,
        verifiedById: null,
        attachPackageToTemplate: false,
        packagesIspTemplate: {
          name: "",
          speedProfile: {
            name: "",
            contentionRatio: ""
          }
        },
        hasSpecificTerms: false,
        specificTerms: '',
        isActive: true,
        isDeleted: false
      }
    };
  },
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
 
  watch: {
    "locationnetworks": {
      immediate: true,
      handler(value) {
        if(value){
          this.fetchAllNetworks()
        }
      }
    },
    "editedItem.packagesIspTemplate": {
      immediate: true,
      handler(value) {
        try {
          if (value.name !== "") {
            let speedProfileId = value.speedProfileId;
            let packagesFnoById = this.locationPackages.filter(function(el) {
              return (
                el.speedProfileId === speedProfileId && el.isActive === true
              );
            });
            if(packagesFnoById){
           if (packagesFnoById.length > 0) {
              this.packagesFnoById = packagesFnoById[0];
              this.speedErrorMessage = false;
            } else {
              this.speedErrorMessage = true;
            }
            }
           
          }
          if (typeof value === "undefined") {
            this.editedItem.packagesIspTemplate = this.defaultItem.packagesIspTemplate;
          }
        } catch {}
      }
    },
    filterArchivedPackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "archivedPackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterArchivedPackages = false;
      }
    },
    filterActivePackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "activePackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterActivePackages = false;
      }
    },
    filterUnregisteredPackages(value) {
      const route = {
        name: this.$route.name
      };
      if (value === true) {
        route.query = {
          currentTab: "unregisteredPackages",
          locationNetworkId: this.filterNetwork,
          customerId: this.filterIsp,
          speedProfileId: this.filterSpeed,
          packageType: this.filterPackageType
        };
        this.$router.push(route);
        this.filterUnregisteredPackages = false;
      }
    }
  },
mounted(){
   this.initialize();
},
  created() {
   this.initialize();
    const route = {
      name: this.$route.name
    };
    this.$router.push(route);
    //this.createGraphData();
    this.setActiveTabName("packagesOverview");
  },
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  methods: {
    async savePackages(){
     let post =[]
     Api().get('/locationNetwork/basic/'+ this.currentLocationNetworkId).then(async response=>{
  await this.filteredPackagesTable.map(async x => {
               let ispLocationNetworkId = await this.selectedLocationNetwork.availablePackages.filter(
          (el)=> {
            return (
              el.locationNetworkId === this.currentLocationNetworkId &&
              el.packagesFno.id === x.packagesFnoId
            );
          }
        )[0].ispLocationNetworkId;
               post.push({
               name: x.name,
               description:x.description,
               term:x.term, 
               isVerified:true,
               verifiedById: this.$store.state.user.id,
               createdById: this.$store.state.user.id,
               lastModifiedById: this.$store.state.user.id,
               customerOrganisationId: x.customerOrganisationId,
               speedProfileId: x.speedProfileId,
               recurringPriceVatInc :x.recurringPrice,
               onceOffPriceVatInc :x.onceOffPrice,
               customerId:x.customerId,
               isCapped: x.isCapped,
               isFup: x.isFup,
               isPromotion: x.isPromo,
               isShaped: x.isShaped,
               cappedAmountGb: x.cappedAmountGb,
               startDate: new Date(),
               packagesFnoId :x.packagesFnoId, 
               layer3Contention:x.layer3Contention,
               promotionDescription:x.promoDescription,
               organisationId: x.organisationId,
               hasSpecificTerms:x.hasSpecificTerms,
               specificTerms:x.specificTerms,
               locationNetworkId: this.currentLocationNetworkId,
               ispLocationNetworkId: ispLocationNetworkId,
               isDeleted:false,
               isActive:true
                })
              })
     confirm("Are you sure you want to link " + post.length + " packages to " + response.data.name) &&
      Api()
      .post('/customer/bulkPackagesIsps',{
        batch: post
       }).then(response=>{
           this.$emit("packagesIspsSaved");
         this.addNewNetworkPackages=false
       }) 
     })
          
    },
    async addPackageTemplates(network){
      let item = network.unusedPackages
      this.currentLocationNetworkId = network.id
      this.selectedLocationNetwork = await this.locationnetworks.find(x=>x.id==this.currentLocationNetworkId);
      let speedArray =[]
      this.filteredPackages=[]
        await item.filter(function(x){
          if(!speedArray.some(item => item.speedProfileId === x.speedProfileId)){
                speedArray.push({
                  speedProfileId: x.speedProfileId, 
                  packagesFnoId: x.id})
          }
        })
        Api().get('/packagesIspTemplate/byCustomer').then(async response=>{
         await response.data.map(async x=>{
            let fnoPackage = await speedArray.find(y=>y.speedProfileId === x.speedProfileId)
            if(fnoPackage){
          this.filteredPackages.push({
                    cappedAmountGb: x.cappedAmountGb,
                    customerId: x.customerId,
                    customerOrganisationId: x.customerOrganisationId,
                    description: x.description,
                    hasSpecificTerms: x.hasSpecificTerms,
                    id: x.id,
                    isActive: x.isActive,
                    isCapped: x.isCapped,
                    isDeleted:x.isDeleted,
                    isFup:x.isFup,
                    isPromo:x.isPromo,
                    isShaped:x.isShaped,
                    layer3Contention:x.layer3Contention,
                    name: x.name,
                    onceOffPrice: x.onceOffPrice,
                    organisationId: x.organisationId,
                    packageIspCatId: x.packageIspCatId,
                    promoDescription: x.promoDescription,
                    recurringPrice: x.recurringPrice,
                    specificTerms: x.specificTerms,
                    speedProfile: x.speedProfile,
                    speedProfileId: x.speedProfileId,
                    term: x.term,
                    packagesFnoId: fnoPackage.packagesFnoId,                   
                   })            
            }
            })
          this.addNewNetworkPackages=true 
        })
          
    },
    async createGraphData() {
      this.graphLoaded = false;
      let labels = [];
      let layer2Data = [];
      let data = this.layertwousage.sort((a, b) =>
        a.bill_dateto > b.bill_dateto
          ? 1
          : b.bill_dateto > a.bill_dateto
          ? -1
          : 0
      );
      for (let i = 0; i < data.length; i++) {
        await labels.push(this.formatDate(data[i].bill_dateto));
        await layer2Data.push(Math.round(data[i].rate_95th / 10000) / 100);
      }
      this.layer2Graph = {
        labels: labels,
        datasets: [
          {
            label: "Monthly Report",
            data: layer2Data,
            backgroundColor: [
              "rgba(38,231,147, 0.2)",
              "rgba(255, 99, 132, 0.2)"
            ],
            borderColor: ["rgba(38,231,147, 1)", "rgba(255, 99, 132, 1)"],
            borderWidth: 1
          }
        ]
      };
      this.layer2GraphOptions = {
        title: {
          display: true,
          text: "Layer 2 Usage"
        }
      };
      this.graphLoaded = true;
    },
    async packageSummaryredirect(networkId) {
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function(el) {
          return el.url === "/packageSummary/:locationNetworkId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/packageSummary/" + networkId });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    async bulkUpdateIspPackages() {
      for (let a = 0; a < this.activepackagesisps.length; a++) {
        await Api()
          .put("/customer/packagesIsps/" + this.activepackagesisps[a].id, {
            customerOrganisationId: this.activepackagesisps[a].customer
              .customerOrganisationId
          })
          .then(response => {});
      }
      for (let b = 0; b < this.archivedpackagesisps.length; b++) {
        await Api()
          .put("/customer/packagesIsps/" + this.archivedpackagesisps[b].id, {
            customerOrganisationId: this.archivedpackagesisps[b].customer
              .customerOrganisationId
          })
          .then(response => {});
      }
      for (let c = 0; c < this.unregisteredpackagesisps.length; c++) {
        await Api()
          .put(
            "/customer/packagesIsps/" + this.unregisteredpackagesisps[c].id,
            {
              customerOrganisationId: this.unregisteredpackagesisps[c].customer
                .customerOrganisationId
            }
          )
          .then(response => {});
      }
    },
    async previewPackage(item) {
      this.packagePreviewCard = [];
      item.customerOrganisation=this.$store.state.currentOrg.org
      console.log(item)
      await this.packagePreviewCard.push(item);
      this.previewPackageModal = true;
    },
    async bulkAddTemplatesToGroup() {
      let existingPackageTemplates = [];
      let newPackageTemplates = [];
      if (this.packagesisptemplatesArray.length > 0) {
        for (let x = 0; x < this.packagesisptemplatesArray.length; x++) {
          if (this.packagesisptemplatesArray[x].isActive) {
            await existingPackageTemplates.push(
              this.packagesisptemplatesArray[x].id
            );
          }
        }
      }

      for (let a = 0; a < this.selectedTemplates.length; a++) {
        if (!existingPackageTemplates.includes(this.selectedTemplates[a].id)) {
          await Api()
            .post("/packagesIspCatPackagesIspTemplate", {
              packagesIspCatId: this.packagesIspCatObj.id,
              packagesIspTemplateId: this.selectedTemplates[a].id,
              isActive: true,
              isDeleted: false
            })
            .then(response => {
              this.packagesisptemplatesArray.push(this.selectedTemplates[a]);
            });
        }
      }
      this.$emit("groupTemplateChange");
    },
    async bulkAddNetworksToGroup() {
      let existingNetworks = [];
      if (this.packageTemplateLocationNetworks.length > 0) {
        for (let x = 0; x < this.packageTemplateLocationNetworks.length; x++) {
          if (this.packageTemplateLocationNetworks[x].isActive) {
            await existingNetworks.push(
              this.packageTemplateLocationNetworks[x].id
            );
          }
        }
      }

      for (let a = 0; a < this.selectedNetworks.length; a++) {
        if (!existingNetworks.includes(this.selectedNetworks[a].id)) {
          await Api()
            .post("/packagesIspCatLocationNetwork", {
              packagesIspCatId: this.packagesIspCatObj.id,
              locationNetworkId: this.selectedNetworks[a].id,
              isActive: true,
              isDeleted: false
            })
            .then(async response => {
              await this.packageTemplateLocationNetworks.push(
                this.selectedNetworks[a]
              );
            });
        }
      }
      this.$emit("groupTemplateChange");
    },
    updateIspPackages() {
      Api()
        .get("/packagesIsps")
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].packagesFno.isActive === false ||
              response.data[i].packagesFno.isDeleted === true
            ) {
              Api().put("/packagesIsps/" + response.data[i].id, {
                isActive: false,
                isDeleted: true
              });
            }
          }
        });
    },
    removeTemplatePackageFromGroup(item) {
      let index = 0;
      let arrayIndex = this.packagesisptemplatesArray.indexOf(item);
      for (
        let i = 0;
        i < this.packagesIspCatPackagesIspTemplatesArray.length;
        i++
      ) {
        if (
          item ==
          this.packagesIspCatPackagesIspTemplatesArray[i].packagesIspTemplate
        ) {
          index = i;
        }
      }

      confirm("Are you sure you want to remove this package from the group?") &&
        Api()
          .put(
            "/packagesIspCatPackagesIspTemplate/" +
              this.packagesIspCatPackagesIspTemplatesArray[index].id,
            {
              isActive: false,
              isDeleted: true
            }
          )
          .then(async response => {
            await this.packagesisptemplatesArray.splice(arrayIndex, 1);
            this.$emit("groupTemplateChange");
          });
    },
    removePackageFromTemplate(item) {
      confirm(
        "Are you sure you want to unlink this package? WARNING: This will not delete the Data Package"
      ) &&
        Api()
          .put("/customer/packagesIsps/" + item.id, {
            packagesIspTemplateId: null
          })
          .then(async response => {
            this.$emit("groupTemplateChange");
            this.$emit("packagesIspsSaved");
            this.initialize();
          });
    },
    removeNetworkFromGroup(item) {
      let index = 0;
      let arrayIndex = this.packageTemplateLocationNetworks.indexOf(item);
      for (let i = 0; i < this.packagesIspCatLocationNetworkArray.length; i++) {
        if (
          item == this.packagesIspCatLocationNetworkArray[i].locationNetwork
        ) {
          index = i;
        }
      }

      confirm("Are you sure you want to remove this network from the group?") &&
        Api()
          .put(
            "/packagesIspCatLocationNetwork/" +
              this.packagesIspCatLocationNetworkArray[index].id,
            {
              isActive: false,
              isDeleted: true
            }
          )
          .then(async response => {
            await this.packageTemplateLocationNetworks.splice(arrayIndex, 1);
            this.$emit("groupTemplateChange");
          });
    },
    enterEvent() {},
    specifyTab() {
      this.filterActivePackages = true;
    },
    addPackageTemplateCheck() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        // this.packagesIspTemplateObj.hasSpecificTerms = false
        this.addPackageTemplate = true;
      }
    },
    fetchPackagesIsps() {
      Api()
        .get("/customer/packagesIsps/active")
        .then(response => {
          this.activePackagesIsps = response.data;
        });
      Api()
        .get("/customer/packagesIsps/unregistered")
        .then(response => {
          this.unregisteredPackagesIsps = response.data;
        });
    },
    fetchPackagesFno() {
      Api()
        .get("/packagesFnos/basic/active")
        .then(response => {
          this.packagesFnos = response.data;
        });
    },
    fetchLocationNetworks() {
      Api()
        .get("/locationnetworks")
        .then(response => {
          this.locationNetworks = response.data;
        });
    },
    async fetchSelectedNetwork(networkId) {
      this.selectedLocationNetwork = await this.locationnetworks.filter(
        function(el) {
          return el.id === networkId;
        }
      )[0];
      let packages = [];
      this.locationPackages = [];
      this.locationPackagesId = [];
      let speedProfileIdList = [];
      for (
        let i = 0;
        i < this.selectedLocationNetwork.availablePackages.length;
        i++
      ) {
        await packages.push(
          this.selectedLocationNetwork.availablePackages[i].packagesFno
        );
      }
      this.locationPackages = packages;

      for (let i = 0; i < this.locationPackages.length; i++) {
        if (
          !speedProfileIdList.includes(this.locationPackages[i].speedProfileId)
        ) {
          speedProfileIdList.push(this.locationPackages[i].speedProfileId);
        }
      }
      for (let x = 0; x < this.packagesisptemplates.length; x++) {
        if (
          speedProfileIdList.includes(
            this.packagesisptemplates[x].speedProfileId
          )
        ) {
          await this.packagesIspTemplatesLocationNetwork.push(
            this.packagesisptemplates[x]
          );
        }
      }
      // Api()
      //   .get("/locationnetworks/" + networkId)
      //   .then(response => {
      //     this.selectedLocationNetwork = response.data[0];
      //   });
    },
    formatDate(date) {
      if (date == null) {
        return null;
      } else {
        return dateformat(date, "dd/mm/yyyy");
      }
    },
    getPackageDetails(packagesFnoId) {
      Api()
        .get("/packagesFnoLocationNetwork/showByFnoPackages/" + packagesFnoId)
        .then(response => {
          this.packagesFnoById = response.data[0].packagesFno;
        });
    },
    initialize() {
     // this.fetchPackagesFno();
    // this.fetchAllNetworks()
    },
    async fetchAllNetworks(){
      this.isLoading=true
      this.newNetworks=[]
      this.activeNetworks=[]
      
      
     await this.locationnetworks.filter(async (x)=>{
       if(x.currentPackages){
        if(x.currentPackages.length >= 1){
             this.activeNetworks.push(x)
           }else{
             this.newNetworks.push(x)
           }
          await this.doAsyncStuff() 
    }
      
        })

        this.key++
    },
    doAsyncStuff() {
      return this.isLoading=false
    },
    grossProfit(IspPrice, FnoPrice) {
      return parseFloat(IspPrice) - parseFloat(FnoPrice) * (1 + $VAT);
    },

    async getLocationPackages(networkId) {
      // this.locationPackages = [];
      this.locationPackagesId = [];
      let speedProfileIdList = [];
      this.packagesIspTemplatesLocationNetwork = [];

      // await Api()
      //   .get(
      //     "/customer/packagesIsps/all/packagesOnNetwork/"+networkId
      //   )
      //   .then(async response => {
      //     this.locationPackages = [];
      //     this.locationPackagesId = [];
      //     let speedProfileIdList = [];
      //     this.packagesIspTemplatesLocationNetwork = [];
      //     // this.locationPackages = response.data;
      //     for (let i = 0; i < response.data.length; i++) {
      //       if (
      //         !this.locationPackagesId.includes(
      //           response.data[i].packagesFnoId
      //         )
      //       ) {
      //         this.locationPackagesId.push(response.data[i].packagesFnoId)
      //         this.locationPackages.push(response.data[i].packagesFno);
      //         speedProfileIdList.push(
      //           response.data[i].packagesFno.speedProfileId
      //         );
      //       }
      //     }
      //     for (let x = 0; x < this.packagesisptemplates.length; x++) {
      //       if (
      //         speedProfileIdList.includes(
      //           this.packagesisptemplates[x].speedProfileId
      //         )
      //       ) {
      //         await this.packagesIspTemplatesLocationNetwork.push(
      //           this.packagesisptemplates[x]
      //         );
      //       }
      //     }
      //   });
    },
    async getSpeedProfileTemplates(speedProfileId) {
      let customerId = this.editedItem.customerId;
      this.speedProfileTemplates = await this.packagesisptemplates.filter(
        function(el) {
          return el.speedProfileId === speedProfileId;
        }
      );
    },
    formattedDate: function(date) {
      return date ? format(date, "Do MMM YYYY") : "";
    },

    editItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedIndex = this.activePackagesIsps.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editDialog = true;
        this.basicInformation = true;
        this.pricingTerm = false;
        this.packageSummary = false;
        this.getPackageDetails(this.editedItem.packagesFnoId);
        this.fetchSelectedNetwork(this.editedItem.locationNetworkId);
        this.getLocationPackages(this.editedItem.locationNetworkId);
        if (this.editedItem.packagesIspTemplateId !== null) {
          this.editedItem.attachPackageToTemplate = true;
        }

        if (this.editedItem.endDate !== null) {
          this.editedItem.endDate = new Date(this.editedItem.endDate)
            .toISOString()
            .substr(0, 10);
        }
        if (this.editedItem.startDate !== null) {
          this.editedItem.startDate = new Date(this.editedItem.startDate)
            .toISOString()
            .substr(0, 10);
        }
        this.editDialog = true;
      }
    },
    async editPackageGroupItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.packagesIspCatObj = Object.assign({}, item);
        this.packagesisptemplatesArray = [];
        this.selectedTemplates = [];
        this.packagesIspCatPackagesIspTemplatesArray = [];
        this.packageTemplateLocationNetworks = [];
        this.packagesIspCatLocationNetworkArray = [];
        for (
          let i = 0;
          i < this.packagesIspCatObj.packagesIspCatPackagesIspTemplates.length;
          i++
        ) {
          if (
            this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
              .isActive &&
            !this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
              .isDeleted
          ) {
            if (
              this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                .packagesIspTemplate.isActive &&
              !this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                .packagesIspTemplate.isDeleted
            ) {
              this.packagesisptemplatesArray.push(
                this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                  .packagesIspTemplate
              );
              this.selectedTemplates.push(
                this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
                  .packagesIspTemplate
              );
              this.packagesIspCatPackagesIspTemplatesArray.push(
                this.packagesIspCatObj.packagesIspCatPackagesIspTemplates[i]
              );
            }
          }
        }
        for (
          let i = 0;
          i < this.packagesIspCatObj.packagesIspCatLocationNetworks.length;
          i++
        ) {
          if (
            this.packagesIspCatObj.packagesIspCatLocationNetworks[i].isActive &&
            !this.packagesIspCatObj.packagesIspCatLocationNetworks[i].isDeleted
          ) {
            this.packageTemplateLocationNetworks.push(
              this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
                .locationNetwork
            );
            this.selectedNetworks.push(
              this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
                .locationNetwork
            );
            this.packagesIspCatLocationNetworkArray.push(
              this.packagesIspCatObj.packagesIspCatLocationNetworks[i]
            );
          }
        }

        let customerId = this.packagesIspCatObj.customerId;
        this.selectablePackagesIspTemplates = this.packagesisptemplates.filter(
          function(el) {
            return el.customerId === customerId;
          }
        );
        this.packageTemplateGroupInfo = true;
        this.packageTemplateGroupAttachedPackages = false;
        this.editPackageGroup = true;
      }
    },
    deletePackageTemplateItem(item) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        let packagesIspTemplateId = item.id;
        this.packagesIspTemplateAttachedPackages = this.activepackagesisps.filter(
          function(el) {
            return el.packagesIspTemplateId === packagesIspTemplateId;
          }
        );
        confirm(
          "Are you sure you would like to delete this Package Template? WARNING: This will delete all linked Data Packages"
        ) &&
          Api()
            .put("/customer/packagesIspTemplate/" + item.id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              this.$emit("groupTemplateChange");
              this.editPackageTemplate = false;
            });
        for (
          let i = 0;
          i < this.packagesIspTemplateAttachedPackages.length;
          i++
        ) {
          Api().put(
            "customer/packagesIsps/" +
              this.packagesIspTemplateAttachedPackages[i].id,
            {
              isActive: false,
              isDeleted: true
            }
          );
        }
        this.initialize();
        this.$emit("packagesIspsSaved");
      }
    },
    editPackageTemplateItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.packagesIspTemplateObj = Object.assign({}, item);

        let packagesIspTemplateId = this.packagesIspTemplateObj.id;
        this.packagesIspTemplateAttachedPackages = this.activepackagesisps.filter(
          function(el) {
            return el.packagesIspTemplateId === packagesIspTemplateId;
          }
        );
      }
    },
    registerItem(item) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.editedIndex = this.unregisteredPackagesIsps.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (
          this.editedItem.layer3Contention === "" ||
          this.editedItem.layer3Contention === null
        ) {
          this.editedItem.layer3Contention =
            item.packagesFno.speedProfile.contentionRatio;
        }
        if (this.editedItem.endDate !== null) {
          this.editedItem.endDate = new Date(this.editedItem.endDate)
            .toISOString()
            .substr(0, 10);
        }
        if (this.editedItem.startDate !== null) {
          this.editedItem.startDate = new Date(this.editedItem.startDate)
            .toISOString()
            .substr(0, 10);
        }
        (this.editedItem.packagesFnoId = item.packagesFnoId),
          (this.registerDialog = true);
        this.registerDialogToolbar = true;
        this.getSpeedProfileTemplates(item.packagesFno.speedProfileId);
        this.basicInfo = true;
        this.packageSummary = false;
        this.pricingTerm = false;
        this.getPackageDetails(this.editedItem.packagesFnoId);
        this.fetchSelectedNetwork(this.editedItem.locationNetworkId);
        this.getLocationPackages(this.editedItem.locationNetworkId);
      }
    },

    deleteItem(id) {
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm("Are you sure you want to delete this item?") &&
          Api()
            .put("/customer/packagesIsps/" + id, {
              isActive: false,
              isDeleted: true
            })
            .then(response => {
              this.initialize();
              this.$emit("packagesIspsSaved");
            });
      }
    },
    clearFields() {
      this.editedItem = Object.assign({}, this.defaultItem);
      // this.editedItem={}
    },

    close() {
      this.dialog = false;
      this.newDialog = false;
      this.editDialog = false;
      this.registerDialogToolbar = false;
      this.registerDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async verifyItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let isVerified = false;
        if (item.isVerified === null || item.isVerified === false) {
          isVerified = true;
        } else {
          isVerified = false;
        }
        confirm("Are you sure you would like to verify this package?") &&
          (await Api()
            .put("customer/packagesIsps/" + item.id, {
              isVerified: isVerified,
              verifiedById: this.$store.state.user.id
            })
            .then(async response => {
              // this.$emit("packagesIspsSaved");
              // this.$emit("groupTemplateChange");
              let index = await this.activepackagesisps.indexOf(item);
              this.activepackagesisps[index].isVerified = isVerified;
              if (typeof this.packagesIspTemplateObj !== "undefined") {
                this.editPackageTemplateItem(this.packagesIspTemplateObj);
              }
            }));
      }
    },
    bulkVerify() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let numberOfPackages = this.selected.length;
        let cf = confirm(
          "Are you sure you would like to verify " +
            numberOfPackages +
            " package(s)?"
        );
        if (cf == true) {
          this.loadingPackages = true;
          for (let i = 0; i < this.selected.length; i++) {
            Api().put("/customer/packagesIsps/" + this.selected[i].id, {
              isVerified: true,
              verifiedById: this.$store.state.user.id
            });
          }
          this.$emit("packagesIspsSaved");
          this.loadingPackages = false;
        }
      }
    },
    bulkDelete() {
      if (this.authDelete(this.$store.state.currentRoute)) {
        let numberOfPackages = this.selected.length;
        this.loadingPackages = true;
        let cf = confirm(
          "Are you sure you would like to delete " +
            numberOfPackages +
            " package(s)?"
        );
        if (cf == true) {
          this.loadingPackages = true;

          for (let i = 0; i < this.selected.length; i++) {
            Api().put("/customer/packagesIsps/" + this.selected[i].id, {
              isActive: false,
              isDeleted: true,
              lastModifiedById: this.$store.state.user.id
            });
          }
          this.$emit("packagesIspsSaved");
          this.loadingPackages = false;
        }
      }
    },
    bulkShow() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let numberOfPackages = this.selected.length;
        let cf = confirm(
          "Are you sure you would like to make " +
            numberOfPackages +
            " package(s) available on the Application Page?"
        );
        if (cf == true) {
          this.loadingPackages = true;
          for (let i = 0; i < this.selected.length; i++) {
            Api().put("/customer/packagesIsps/" + this.selected[i].id, {
              isActive: true,
              lastModifiedById: this.$store.state.user.id
            });
          }
          this.$emit("packagesIspsSaved");
          this.loadingPackages = false;
        }
      }
    },
    bulkHide() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let numberOfPackages = this.selected.length;
        let cf = confirm(
          "Are you sure you would like to hide " +
            numberOfPackages +
            " package(s)?"
        );
        if (cf == true) {
          this.loadingPackages = true;
          for (let i = 0; i < this.selected.length; i++) {
            Api().put("/customer/packagesIsps/" + this.selected[i].id, {
              isActive: false,
              lastModifiedById: this.$store.state.user.id
            });
          }
          this.$emit("packagesIspsSaved");
          this.loadingPackages = false;
        }
      }
    },
    async showHideItem(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to change the visibility of this package?"
        ) &&
          (await Api()
            .put("/customer/packagesIsps/" + item.id, {
              isActive: !item.isActive,
              lastModifiedById: this.$store.state.user.id
            })
            .then(async response => {
              let index = await this.activepackagesisps.indexOf(item);
              this.activepackagesisps[index].isActive = !item.isActive;
              if (typeof this.packagesIspTemplateObj !== "undefined") {
                this.editPackageTemplateItem(this.packagesIspTemplateObj);
              }
            }));
      }
    },
    saveNewPackageTemplate() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        if(typeof this.packagesIspTemplateObj.hasSpecificTerms === 'undefined'){
          this.packagesIspTemplateObj.hasSpecificTerms = false
        }
        Api()
          .post("/packagesIspTemplate", {
            name: this.packagesIspTemplateObj.name,
            description: this.packagesIspTemplateObj.description,
            speedProfileId: this.packagesIspTemplateObj.speedProfileId,
            recurringPrice: this.packagesIspTemplateObj.recurringPrice,
            onceOffPrice: this.packagesIspTemplateObj.onceOffPrice,
            isFup: this.packagesIspTemplateObj.isFup,
            isShaped: this.packagesIspTemplateObj.isShaped,
            isPromo: this.packagesIspTemplateObj.isPromo,
            promoDescription: this.packagesIspTemplateObj.promoDescription,
            isCapped: this.packagesIspTemplateObj.isCapped,
            cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
            term: this.packagesIspTemplateObj.term,
            hasSpecificTerms: this.packagesIspTemplateObj.hasSpecificTerms,
            specificTerms: this.packagesIspTemplateObj.specificTerms,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.addPackageTemplate = false;
            this.$emit("groupTemplateChange");
          });
      }
    },
    addItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.newDialog = true;
        this.basicInformation = true;
        this.pricingTerm = false;
        this.packageSummary = false;
        this.clearFields();
      }
    },
    savePackageTemplate() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        // if(this.packagesIspTemplateObj.customerId===null){
        //   this.packagesIspTemplateObj.customerId =this.$store.state.customerId
        // }
        confirm(
          "Are you sure you would like to update this Package Template? WARNING: This will update all linked Data Packages."
        ) &&
          Api()
            .put(
              "/customer/packagesIspTemplate/" + this.packagesIspTemplateObj.id,
              {
                name: this.packagesIspTemplateObj.name,
                description: this.packagesIspTemplateObj.description,
                // customerId: this.packagesIspTemplateObj.customerId,
                speedProfileId: this.packagesIspTemplateObj.speedProfileId,
                recurringPrice: this.packagesIspTemplateObj.recurringPrice,
                onceOffPrice: this.packagesIspTemplateObj.onceOffPrice,
                isFup: this.packagesIspTemplateObj.isFup,
                isShaped: this.packagesIspTemplateObj.isShaped,
                isPromo: this.packagesIspTemplateObj.isPromo,
                promoDescription: this.packagesIspTemplateObj.promoDescription,
                isCapped: this.packagesIspTemplateObj.isCapped,
                cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
                // layer3Contention: this.packagesIspTemplateObj.layer3Contention,
                term: this.packagesIspTemplateObj.term,
                 hasSpecificTerms: this.packagesIspTemplateObj.hasSpecificTerms,
                specificTerms: this.packagesIspTemplateObj.specificTerms,

                isActive: true,
                isDeleted: false
              }
            )
            .then(response => {
              this.$emit("groupTemplateChange");
              this.$emit("packagesIspsSaved");
            });
        for (
          let i = 0;
          i < this.packagesIspTemplateAttachedPackages.length;
          i++
        ) {
          Api().put(
            "/customer/packagesIsps/" +
              this.packagesIspTemplateAttachedPackages[i].id,
            {
              name: this.packagesIspTemplateObj.name,
              description: this.packagesIspTemplateObj.description,
              recurringPriceVatInc: this.packagesIspTemplateObj.recurringPrice,
              onceOffPriceVatInc: this.packagesIspTemplateObj.onceOffPrice,
              isFup: this.packagesIspTemplateObj.isFup,
              isShaped: this.packagesIspTemplateObj.isShaped,
              isPromotion: this.packagesIspTemplateObj.isPromo,
              promotionDescription: this.packagesIspTemplateObj
                .promoDescription,
              isCapped: this.packagesIspTemplateObj.isCapped,
              cappedAmountGb: this.packagesIspTemplateObj.cappedAmountGb,
              term: this.packagesIspTemplateObj.term,
              lastModifiedById: this.$store.state.user.id
            }
          );
        }
        this.$emit("packagesIspsSaved");
        this.initialize();
        this.editPackageTemplate = false;
      }
    },
    saveNewPackageGroup() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/packagesIspCats", {
            customerId: this.packagesIspCatObj.customerId,
            name: this.packagesIspCatObj.name,
            code: this.packagesIspCatObj.code,
            description: this.packagesIspCatObj.description,
            packageCatType: this.packagesIspCatObj.packageCatType,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.addPackageGroup = false;
            this.$emit("groupTemplateChange");
          });
      }
    },
    savePackageGroup() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let proceed = false;

        confirm(
          "Are you sure you would like to save this Package Group? WARNING: This will attach all linked Data Packages to selected Networks"
        ) && (proceed = true);
        if (proceed) {
          let customerId = this.packagesIspCatObj.customerId;
          if (this.selectedNetworks.length > 0) {
            for (let i = 0; i < this.selectedNetworks.length; i++) {
              let currentPackageTemplates = [];
              let currentNetwork = this.selectedNetworks[i];
              let selectedPackageTemplates = [];
              let availableFnoPackages = [];
              let allIspPackageTemplates = [];
              // console.log(this.selectedNetworks[i])
              // if(typeof this.selectedNetworks[i].packagesIspCatLocationNetworks!=='undefined'){
              //   for(let d=0; d<this.selectedNetworks[i].packagesIspCatLocationNetworks.length;d++){
              //     console.log(this.selectedNetworks[i].packagesIspCatLocationNetworks[d])
              //     for(let e=0;e<this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates.length;e++){
              //       if(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].customerId===customerId&&
              //       this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].isActive&&
              //       !this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e].isDeleted){
              //         console.log(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e])
              //         allIspPackageTemplates.push(this.selectedNetworks[i].packagesIspCatLocationNetworks[d].packageIspCat.packagesIspTemplates[e])
              //       }
              //     }
              //   }
              // }
              if (
                typeof this.selectedNetworks[i].packagesFnoLocationNetworks !==
                "undefined"
              ) {
                for (
                  let b = 0;
                  b <
                  this.selectedNetworks[i].packagesFnoLocationNetworks.length;
                  b++
                ) {
                  this.selectedNetworks[i].packagesFnoLocationNetworks[b];
                  availableFnoPackages.push(
                    this.selectedNetworks[i].packagesFnoLocationNetworks[b]
                      .packagesFno
                  );
                }
              }

              let currentPackages = this.activepackagesisps.filter(function(
                el
              ) {
                return (
                  el.customerId === customerId &&
                  el.locationNetworkId === currentNetwork.id
                );
              });
              for (let y = 0; y < currentPackages.length; y++) {
                currentPackageTemplates.push(
                  currentPackages[y].packagesIspTemplateId
                );
              }
              for (let x = 0; x < this.packagesisptemplatesArray.length; x++) {
                selectedPackageTemplates.push(
                  this.packagesisptemplatesArray[x].id
                );
                if (
                  !currentPackageTemplates.includes(
                    this.packagesisptemplatesArray[x].id
                  )
                ) {
                  for (let c = 0; c < availableFnoPackages.length; c++) {
                    if (
                      this.packagesisptemplatesArray[x].speedProfileId ===
                      availableFnoPackages[c].speedProfileId
                    ) {
                      Api().post("/customer/packagesIsps", {
                        name: this.packagesisptemplatesArray[x].name,
                        description: this.packagesisptemplatesArray[x]
                          .description,
                        onceOffPriceVatInc: this.packagesisptemplatesArray[x]
                          .onceOffPrice,
                        recurringPriceVatInc: this.packagesisptemplatesArray[x]
                          .recurringPrice,
                        isPromotion: this.packagesisptemplatesArray[x].isPromo,
                        promotionDescription: this.packagesisptemplatesArray[x]
                          .promoDescription,
                        term: this.packagesisptemplatesArray[x].term,
                        isCapped: this.packagesisptemplatesArray[x].isCapped,
                        isShaped: this.packagesisptemplatesArray[x].isShaped,
                        layer3Contention: this.packagesisptemplatesArray[x]
                          .layer3Contention,
                        cappedAmountGb: this.packagesisptemplatesArray[x]
                          .cappedAmountGb,
                        isFup: this.packagesisptemplatesArray[x].isFup,
                        startDate: new Date(),
                        endDate: null,
                        packagesFnoId: availableFnoPackages[c].id,
                        locationNetworkId: this.selectedNetworks[i].id,
                        customerId: this.packagesisptemplatesArray[x]
                          .customerId,
                        isVerified: false,
                        isRegistered: true,
                        createdById: this.$store.state.user.id,
                        lastModifiedById: this.$store.state.user.id,
                        verifiedById: null,
                        packagesIspTemplateId: this.packagesisptemplatesArray[x]
                          .id,
                        isActive: false
                      });
                    }
                  }
                }
              }
              Api()
                .get(
                  "/packagesIspCatLocationNetwork/byNetwork/" +
                    this.selectedNetworks[i].id
                )
                .then(async response => {
                  let packagesIspCats = response.data;
                  if (typeof response.data !== "undefined") {
                    for (let f = 0; f < packagesIspCats.length; f++) {
                      if (
                        packagesIspCats[f].packagesIspCat.customerId ===
                        customerId
                      ) {
                        for (
                          let g = 0;
                          g <
                          packagesIspCats[f].packagesIspCat
                            .packagesIspCatPackagesIspTemplates.length;
                          g++
                        ) {
                          for (
                            let h = 0;
                            h <
                            packagesIspCats[f].packagesIspCat
                              .packagesIspCatPackagesIspTemplates[g]
                              .packagesIspTemplates.length;
                            h++
                          ) {
                            if (
                              packagesIspCats[f].packagesIspCat
                                .packagesIspCatPackagesIspTemplates[g]
                                .packagesIspTemplates[h].isActive &&
                              !packagesIspCats[f].packagesIspCat
                                .packagesIspCatPackagesIspTemplates[g]
                                .packagesIspTemplates[h].isDeleted
                            ) {
                              await allIspPackageTemplates.push(
                                packagesIspCats[f].packagesIspCat
                                  .packagesIspCatPackagesIspTemplates[g]
                                  .packagesIspTemplates[h]
                              );
                            }
                          }
                        }
                      }
                    }
                  }
                });
            }

            Api()
              .put("/packagesIspCats/" + this.packagesIspCatObj.id, {
                customerId: this.packagesIspCatObj.customerId,
                name: this.packagesIspCatObj.name,
                code: this.packagesIspCatObj.code,
                description: this.packagesIspCatObj.description,
                packageCatType: this.packagesIspCatObj.packageCatType,
                isActive: true,
                isDeleted: false
              })
              .then(response => {
                this.editPackageGroup = false;
                this.$emit("groupTemplateChange");
              });
          }
          this.$emit("packagesIspsSaved");
          this.initialize();
        }
      }
    },

    createPackageFromTemplate() {
      let speedProfileId = this.editedItem.packagesIspTemplate.speedProfileId;
      let fnoPackages = this.locationPackages.filter(function(el) {
        return el.speedProfileId === speedProfileId;
      });

      for (let i = 0; i < fnoPackages.length; i++) {
        let packagesFnoId = fnoPackages[i].id;
        let locationNetworkId = this.editedItem.locationNetworkId;
        let ispLocationNetworkId = this.selectedLocationNetwork.availablePackages.filter(
          function(el) {
            return (
              el.locationNetworkId === locationNetworkId &&
              el.packagesFno.id === packagesFnoId
            );
          }
        )[0].ispLocationNetworkId;
        Api().post("/customer/packagesIsps", {
          name: this.editedItem.packagesIspTemplate.name,
          description: this.editedItem.packagesIspTemplate.description,
          onceOffPriceVatInc: this.editedItem.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.editedItem.packagesIspTemplate
            .recurringPrice,
          isPromotion: this.editedItem.packagesIspTemplate.isPromo,
          promotionDescription: this.editedItem.packagesIspTemplate
            .promoDescription,
          term: this.editedItem.packagesIspTemplate.term,
          isCapped: this.editedItem.packagesIspTemplate.isCapped,
          isShaped: this.editedItem.packagesIspTemplate.isShaped,
          cappedAmountGb: this.editedItem.packagesIspTemplate.cappedAmountGb,
          isFup: this.editedItem.packagesIspTemplate.isFup,
          fupUrl: this.editedItem.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: fnoPackages[i].id,
          locationNetworkId: this.editedItem.locationNetworkId,
          ispLocationNetworkId: ispLocationNetworkId,
          isVerified: false,
          isRegistered: true,
          createdById: this.$store.state.user.id,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
          customerOrganisationId: this.$store.state.currentOrg.org.id,
          isActive: this.editedItem.isActive
        });
      }
      this.$emit("packagesIspsSaved");
      this.initialize();
      this.close();
    },
    registerPackageFromTemplate() {
      Api()
        .put("/customer/packagesIsps/" + this.editedItem.id, {
          name: this.editedItem.packagesIspTemplate.name,
          description: this.editedItem.packagesIspTemplate.description,
          onceOffPriceVatInc: this.editedItem.packagesIspTemplate.onceOffPrice,
          recurringPriceVatInc: this.editedItem.packagesIspTemplate
            .recurringPrice,
          isPromotion: this.editedItem.packagesIspTemplate.isPromo,
          promotionDescription: this.editedItem.packagesIspTemplate
            .promoDescription,
          term: this.editedItem.packagesIspTemplate.term,
          isCapped: this.editedItem.packagesIspTemplate.isCapped,
          isShaped: this.editedItem.packagesIspTemplate.isShaped,
          layer3Contention: this.editedItem.layer3Contention,
          cappedAmountGb: this.editedItem.packagesIspTemplate.cappedAmountGb,
          isFup: this.editedItem.packagesIspTemplate.isFup,
          fupUrl: this.editedItem.packagesIspTemplate.fupUrl,
          startDate: new Date(),
          endDate: null,
          packagesFnoId: this.packagesFnoById.id,
          locationNetworkId: this.editedItem.locationNetworkId,
          isVerified: false,
          isRegistered: true,
          createdById: this.editedItem.createdById,
          lastModifiedById: this.$store.state.user.id,
          verifiedById: null,
          packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
          isActive: this.editedItem.isActive
        })
        .then(response => {
          this.$emit("packagesIspsSaved");
          this.initialize();
        });
      this.close();
      this.registerDialog = false;
      this.pricingTerm = false;
    },
    async save() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.locationNetworkId == "") {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (
        this.editedItem.onceOffPriceVatInc == "" &&
        !this.editedItem.onceOffPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (
        this.editedItem.recurringPriceVatInc == "" &&
        !this.editedItem.recurringPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        if (this.editedItem.attachPackageToTemplate) {
          let packagesFnoId = this.packagesFnoById.id;
        let locationNetworkId = this.editedItem.locationNetworkId;
        let ispLocationNetworkId = await this.selectedLocationNetwork.availablePackages.filter(
          function(el) {
            return (
              el.locationNetworkId === locationNetworkId &&
              el.packagesFno.id === packagesFnoId
            );
          }
        )[0].ispLocationNetworkId;
          Api()
            .put("/customer/packagesIsps/" + this.editedItem.id, {
              name: this.editedItem.packagesIspTemplate.name,
              description: this.editedItem.packagesIspTemplate.description,
              onceOffPriceVatInc: this.editedItem.packagesIspTemplate
                .onceOffPrice,
              recurringPriceVatInc: this.editedItem.packagesIspTemplate
                .recurringPrice,
              isPromotion: this.editedItem.packagesIspTemplate.isPromo,
              promotionDescription: this.editedItem.packagesIspTemplate
                .promoDescription,
              term: this.editedItem.packagesIspTemplate.term,
              isCapped: this.editedItem.packagesIspTemplate.isCapped,
              isShaped: this.editedItem.packagesIspTemplate.isShaped,
              cappedAmountGb: this.editedItem.packagesIspTemplate
                .cappedAmountGb,
              isFup: this.editedItem.packagesIspTemplate.isFup,
              startDate: this.editedItem.startDate,
              endDate: this.editedItem.endDate,
              packagesFnoId: this.packagesFnoById.id,
              locationNetworkId: this.editedItem.locationNetworkId,
              ispLocationNetworkId: ispLocationNetworkId,
              isVerified: this.editedItem.isVerified,
              createdById: this.editedItem.createdById,
              lastModifiedById: this.$store.state.user.id,
              verifiedById: this.editedItem.verifiedById,
              packagesIspTemplateId: this.editedItem.packagesIspTemplate.id,
              hasSpecificTerms: this.editedItem.packagesIspTemplate.hasSpecificTerms,
              specificTerms: this.editedItem.packagesIspTemplate.specificTerms,
              isActive: this.editedItem.isActive
            })
            .then(response => {
              this.$emit("packagesIspsSaved");
              this.initialize();
            });
        } else {
          let packagesFnoId = this.packagesFnoById.id;
        let locationNetworkId = this.editedItem.locationNetworkId;
        let ispLocationNetworkId = await this.selectedLocationNetwork.availablePackages.filter(
          function(el) {
            return (
              el.locationNetworkId === locationNetworkId &&
              el.packagesFno.id === packagesFnoId
            );
          }
        )[0].ispLocationNetworkId;
          Api()
            .put("/customer/packagesIsps/" + this.editedItem.id, {
              name: this.editedItem.name,
              description: this.editedItem.description,
              onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
              recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
              isPromotion: this.editedItem.isPromotion,
              promotionDescription: this.editedItem.promotionDescription,
              term: this.editedItem.term,
              isCapped: this.editedItem.isCapped,
              isShaped: this.editedItem.isShaped,
              cappedAmountGb: this.editedItem.cappedAmountGb,
              isFup: this.editedItem.isFup,
              fupUrl: this.editedItem.fupUrl,
              startDate: this.editedItem.startDate,
              endDate: this.editedItem.endDate,
              packagesFnoId: this.packagesFnoById.id,
              locationNetworkId: this.editedItem.locationNetworkId,
              ispLocationNetworkId: ispLocationNetworkId,
              isVerified: this.editedItem.isVerified,
              createdById: this.editedItem.createdById,
              lastModifiedById: this.$store.state.user.id,
              verifiedById: this.editedItem.verifiedById,
              packagesIspTemplateId: null,
               hasSpecificTerms: this.editedItem.hasSpecificTerms,
              specificTerms: this.editedItem.specificTerms,
              isActive: this.editedItem.isActive
            })
            .then(response => {
              this.$emit("packagesIspsSaved");
              this.initialize();
            });
        }

        this.close();
      }
    },
    async saveNew() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.locationNetworkId == "") {
        proceed = false;
        confirm("Please select a location network.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (this.editedItem.onceOffPriceVatInc == "") {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (this.editedItem.recurringPriceVatInc == "") {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        if (this.editedItem.description != true) {
          this.editedItem.description = null;
        }
        if (this.editedItem.isPromotion != true) {
          this.editedItem.isPromotion = false;
          this.editedItem.endDate = null;
        }
        if (this.editedItem.isCapped != true) {
          this.editedItem.isCapped = false;
          this.editedItem.cappedAmountGb = null;
        }
        if (this.editedItem.isFup != true) {
          this.editedItem.isFup = false;
        }
        let packagesFnoId = this.editedItem.packagesFnoId
        let locationNetworkId = this.editedItem.locationNetworkId;
        let ispLocationNetworkId = await this.selectedLocationNetwork.availablePackages.filter(
          function(el) {
            return (
              el.locationNetworkId === locationNetworkId &&
              el.packagesFno.id === packagesFnoId
            );
          }
        )[0].ispLocationNetworkId;
        Api()
          .post("/customer/packagesIsps", {
            name: this.editedItem.name,
            description: this.editedItem.description,
            onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
            recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
            isPromotion: this.editedItem.isPromotion,
            term: this.editedItem.term,
            isCapped: this.editedItem.isCapped,
            cappedAmountGb: this.editedItem.cappedAmountGb,
            isShaped: this.editedItem.isShaped,
            isFup: this.editedItem.isFup,
            fupUrl: this.editedItem.fupUrl,
            startDate: this.editedItem.startDate,
            endDate: this.editedItem.endDate,
            packagesFnoId: this.editedItem.packagesFnoId,
            locationNetworkId: this.editedItem.locationNetworkId,
            ispLocationNetworkId: ispLocationNetworkId,
            isRegistered: true,
            isVerified: false,
            createdById: this.$store.state.user.id,
            lastModifiedById: this.$store.state.user.id
          })
          .then(response => {
            console.log(response.data)
            this.$emit("packagesIspsSaved");
            this.initialize();
          });
        this.close();
        this.newDialog = false;
        this.packageSummary = false;
      }
    },
    registerNew() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (this.editedItem.customerId == "") {
        proceed = false;
        confirm("Please select an internet service provider.");
      }
      if (this.editedItem.packagesFnoId == "") {
        proceed = false;
        confirm("Please select a fno package.");
      }
      if (this.editedItem.term == "") {
        proceed = false;
        confirm("Please select a contract term.");
      }
      if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (
        this.editedItem.onceOffPriceVatInc == "" &&
        !this.editedItem.onceOffPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total once off costs to the end Client(incl. VAT)"
        );
      }
      if (
        this.editedItem.recurringPriceVatInc == "" &&
        !this.editedItem.recurringPriceVatInc == 0
      ) {
        proceed = false;
        confirm(
          "Please enter the total monthly price to the end Client (incl. VAT)"
        );
      }
      if (proceed == true) {
        Api()
          .put("/customer/packagesIsps/" + this.editedItem.id, {
            name: this.editedItem.name,
            description: this.editedItem.description,
            onceOffPriceVatInc: this.editedItem.onceOffPriceVatInc,
            recurringPriceVatInc: this.editedItem.recurringPriceVatInc,
            isPromotion: this.editedItem.isPromotion,
            term: this.editedItem.term,
            isCapped: this.editedItem.isCapped,
            cappedAmountGb: this.editedItem.cappedAmountGb,
            layer3Contention: this.editedItem.layer3Contention,
            isFup: this.editedItem.isFup,
            fupUrl: this.editedItem.fupUrl,
            isShaped: this.editedItem.isShaped,
            startDate: this.editedItem.startDate,
            endDate: this.editedItem.endDate,
            packagesFnoId: this.packagesFnoById.id,
            customerId: this.editedItem.customerId,
            isRegistered: true,
            isVerified: false,
            lastModifiedById: this.$store.state.user.id,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.$emit("packagesIspsSaved");
            this.initialize();
          });
        this.close();
        this.registerDialog = false;
        this.packageSummary = false;
      }
    }
  }
};
</script>
<style scoped>
.truncate {
      max-width: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
</style>


